<template>
    <div id="app">
      <div class="login">
        <div class="loginBox">
          <div class="login_close">×</div>
          <div class="loginBox_title">登录</div>
          <div class="loginBox_type">
            <button class="mima">密码登录</button>
            <button class="yanzhengma">验证码登录</button>
          </div>
          <div class="loginBox_inputs">
            <input class="loginBox_inputs_id" type="text" placeholder="请输入账号">
            <input class="loginBox_inputs_pwd" type="text" placeholder="请输入密码">
          </div>
          <button class="loginBox_submit">登录</button>
          <div class="loginBox_tishi">提示：自动注册，账号为手机号，密码为初次登录时设置的密码，验证码登录暂不可用</div>
        </div>
      </div>
      <div class="userinfo">
        <input type="file" id="uptx" accept="image/*" style="display:none;">
        <input type="file" id="upbg" accept="image/*" style="display:none;">
        <div class="closeuserinfo"></div>
        <div class="changebg"></div>
        <div class="tx"></div>
        <div class="nc">
          <input
            type="text"
            class="nc_content"
            value="乔克小铁匠"
          />
        </div>
        <div class="historySet">
          <div class="historySet_title">历史数据设置</div>
          <div class="historySet_tishi">默认设置为近10天，过多将影响性能</div>
          <div>
            <select class="historySet_set">
              <option value="5">近5天</option>
              <option value="10" selected>近10天</option>
              <option value="15">近15天</option>
              <option value="30">近一月</option>
              <option value="0">所有</option>
            </select>
          </div>
        </div>
        <div class="myGeo">
          <div class="myGeo_title">我的图层</div>
          <div class="myGeo_miniBox" style="display: none;">
            <div class="myGeo_miniView"></div>
            <div class="myGeo_miniName"></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="gun">退出登录</div>
      </div>
      <div class="top">
        <div class="userinforBtn"></div>
        <div class="top_title1">
          西南科技大学空气质量监查系统
        </div>
        <div class="top_title1_2">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" style="color:black; font-size: 0.2vw;text-decoration: none;">备案号：蜀ICP备2024059711号-5<br/>川公网安备51070302110615</a>
        </div>
        <div class="top_title2">
          <table>
            <tr>
              <td colspan="3" class="t1">PM2.5</td>
              <td class="t1">AQI</td>
              <td colspan="3" class="t1">PM10</td>
            </tr>
            <tr>
              <td class="top_oth">Max</td>
              <td class="top_oth">Mean</td>
              <td class="top_oth">Min</td>
              <td rowspan="2" class="top_aqi">……</td>
              <td class="top_oth">Max</td>
              <td class="top_oth">Mean</td>
              <td class="top_oth">Min</td>
            </tr>
            <tr class="top_datas">
              <td>……</td>
              <td>……</td>
              <td>……</td>
              <td>……</td>
              <td>……</td>
              <td>……</td>
            </tr>
          </table>
        </div>
      </div>
      <div id="mapView">
        <div class="DistanceTool">
          <div>撤销</div>
          <div>完成</div>
          <div>新增</div>
        </div>
    
        <div class="AreaTool">
          <div>撤销</div>
          <div>完成</div>
          <div>新增</div>
        </div>
        <div class="AQI"></div>
        <button class="mapBLBtn" @click="layersHandle"></button>
        <div class="opacityControl">
          <div id="dur"></div>
          <div class="durFont">1</div>
        </div>
        <div class="miniBox" style="display: none;">
          <div class="miniView"></div>
          <div class="miniName"></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div class="layersBox">
          <div class="miniBox"  >
            <div class="miniView"></div>
            <div class="miniName"></div>
            <div></div>
            <div></div>
            <div></div>
            <div>4</div>
          </div>
        </div>
        <div class="Echart_datas">
          <div class="Echart_datas_ControlBox">
            <div><</div>
            <div>▶</div>
            <div>></div>
          </div>
          <div class="Echart_datas_date">01</div>
          <div id="Echart_datas_left"></div>
          <div id="Echart_datas_right"></div>
        </div>

        <div class="Echart_lines">
          <div class="tishi">请从图层选择线--可利用“距离测量”工具添加线</div>
          <div class="Echart_lines_left"></div>
        </div>

        <div class="Echart_areas">
          <div class="tishi">请从图层选择面--可利用“面积测量”工具添加面</div>
          <div class="Echart_areas_left"></div>
          <div class="Echart_areas_right"></div>
          <div class="Echart_areas_font Echart_areas_left_bottomFont_left">南</div>
          <div class="Echart_areas_font Echart_areas_left_bottomFont_right">北</div>
          <div class="Echart_areas_font Echart_areas_right_bottomFont_left">西</div>
          <div class="Echart_areas_font Echart_areas_right_bottomFont_right">东</div>
        </div>

        <div class="Echart_thres">
          <div class="Echart_thres_left">
            <div id="yuzhi"></div>
            <div id="yuzhiTitle">该图范围</div>

            <div id="Syuzhi"></div>
            <div id="SyuzhiTitle">固定阈值</div>
            <!-- 0<input type="range" id="yuzhi" value="50" min="0" max="300" step="1"">300 -->
          </div>
          <div class="Echart_thres_right">
            <div class="ETR1">颜色设置</div>
            <div class="ETR2">&nbsp;&nbsp;&nbsp;R:<div id="yuzhiR"></div></div>
            <div class="ETR3">&nbsp;&nbsp;&nbsp;G:<div id="yuzhiG"></div></div>
            <div class="ETR4">&nbsp;&nbsp;&nbsp;B:<div id="yuzhiB"></div></div>
          </div>
          
        </div>
      </div>
      <!-- 引入 buttonLeft 组件 -->
      <buttons class="buttons"
        :Leftclick1="Leftclick1"
        :Leftclick2="Leftclick2"
        :Leftclick3="Leftclick3"
        :activeBtn3="activeL3"
        :Leftclick4="Leftclick4"
        :activeL4="activeL4"
        :activeR1="activeR1"
        :activeR3="activeR3"
        :activeR4="activeR4"
        :activeR5="activeR5"
        :Rightclick1="Rightclick1"
        :Rightclick2="Rightclick2"
        :Rightclick3="Rightclick3"
        :Rightclick4="Rightclick4"
        :Rightclick5="Rightclick5"
        :activeButton="activeButton"
  
        :changeBaseMap1="changeBaseMap1"
        :changeBaseMap2="changeBaseMap2"
        :changeBaseMap3="changeBaseMap3"
        :changeBaseMap4="changeBaseMap4"
        :activeBaseMap="activeBaseMap"
      />
      <div class="upData">
        <div class="upTitle">数据上传</div>
        <div class="jiancedianBox">
          <div class="jiancedianwei">01</div>
          <div class="jiancedianwei">02</div>
          <div class="jiancedianwei">03</div>
          <div class="jiancedianwei">04</div>
          <div class="jiancedianwei">05</div>
          <div class="jiancedianwei">06</div>
          <div class="jiancedianwei">07</div>
          <div class="jiancedianwei">08</div>
          <div class="jiancedianwei">09</div>
          <div class="jiancedianwei">10</div>
          <div class="jiancedianwei">11</div>
          <div class="jiancedianwei">12</div>
          <div class="jiancedianwei">13</div>
          <div class="jiancedianwei">14</div>
          <div class="jiancedianwei">15</div>
          <div class="jiancedianwei">16</div>
          <div class="jiancedianwei">17</div>
          <div class="jiancedianwei">18</div>
        </div>
        <div>
          <input
            type="date"
            placeholder=""
            placeholder-class="input-placeholder"
          />
          <button>保存</button>
        </div>
      </div>

      <div class="relituBox">
        <div class="relituControlBox">
          <div><</div>
          <div>&nbsp;▶</div>
          <div>></div>
        </div>
        <div class="timelineBox">
          <div class="timeline"></div>
        </div>
      </div>

      <!-- <div class="bottom" @click="goLogin"> -->
      <div class="bottom">
        <div class="historyBtn historyBtnAct">历史</div>
        <div class="pridectBtn pridectBtnOff">预测</div>
      </div>

      <div class="upDateInfo" style="display:none;">
        <div>数据记录</div>
        <table border="1">
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>
  
    </div>
  </template>
  <script>
  //import {open} from 'shapefile'
  import buttons from "./buttonsControl.vue"; // 引入 buttonLeft 组件
  import loginpage from "./Login.vue"; // 引入 buttonLeft 组件
  import "@arcgis/core/assets/esri/themes/light/main.css";
  import MapView from "@arcgis/core/views/MapView";
  import WebMap from "@arcgis/core/WebMap";
  import Map from "@arcgis/core/Map.js";
  import Draw from "@arcgis/core/views/draw/Draw"
  import { geodesicLength,geodesicArea,union  } from "@arcgis/core/geometry/geometryEngine";
  import Polygon from "@arcgis/core/geometry/Polygon"
  import Polyline from "@arcgis/core/geometry/Polyline"
  import Point from "@arcgis/core/geometry/Point"
  import TextSymbol from "@arcgis/core/symbols/TextSymbol"
  import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol"
  import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol"
  import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol"
  //import FeatureLayer from "@arcgis/core/layers/FeatureLayer"
  //import MapImageLayer from "@arcgis/core/layers/MapImageLayer"
  import ImageryLayer from "@arcgis/core/layers/ImageryLayer"
  //import HeatmapRenderer from "@arcgis/core/renderers/HeatmapRenderer.js";
  import Graphic from "@arcgis/core/Graphic"
  import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer"
  import PopupTemplate from "@arcgis/core/PopupTemplate.js";
  import Extent from "@arcgis/core/geometry/Extent"
  //import FeatureSet from "@arcgis/core/rest/support/FeatureSet";
  //import Geoprocessor from "@arcgis/core/tasks/Geoprocessor";
  //import SpatialReference from "@arcgis/core/geometry/SpatialReference"
  //import RasterStretchRenderer from "@arcgis/core/renderers/RasterStretchRenderer";
  //import FlowRenderer from "@arcgis/core/renderers/FlowRenderer.js";
  //import MosaicRule from "@arcgis/core/layers/support/MosaicRule.js";
  //import RasterFunction from "@arcgis/core/layers/support/RasterFunction.js";
  //import RasterColormapRenderer from "@arcgis/core/renderers/RasterColormapRenderer.js";
  //import AlgorithmicColorRamp from "@arcgis/core/rest/support/AlgorithmicColorRamp";
  //import Color from "@arcgis/core/Color";
  import axios from 'axios';
  import * as echarts from "echarts";
  //import { jsx } from 'react/jsx-runtime';
  //import { color } from 'echarts';
  //import { center, geometry } from '@turf/turf';
  import Query from "@arcgis/core/rest/support/Query.js";
  import Slider from "@arcgis/core/widgets/Slider.js";


  let userid="";
  let HistorySet="10";
  let usercontorl={};
  Object.defineProperty(usercontorl, 'id', {
    get: function() {  
      return userid;
    },
    set: function(newValue) {
      userid = newValue;
      if(userid!=""){user_refresh();}
    }
  });
  //userid检查
  function user_idcheck(id,password){
    var form = new FormData();
    form.append("id", id);
    form.append("password", password);
    $.ajax({
      url: `http://132.232.99.181:1111/BsHandler.aspx?index=14&key=0`,
      type: 'POST',
      data:form,
      processData: false,
      contentType: false,
      success: function (response) {
        if(response!="失败"){
          usercontorl.id=response;
          document.querySelector('.login_close').click();
        }
        else{
          document.querySelector('.loginBox_tishi').innerHTML="密码错误！"
        }
      }
    })
  }
  let GeoList={};
  function user_refresh(){
    $.ajax({
      url: `http://132.232.99.181:1111/BsHandler.aspx?index=12&key=${userid}`,
      type: 'POST',
      processData: false,
      contentType: false,
      success: function (response) {
        let json=JSON.parse(response);
        if(json[0]!=undefined){
          let userinfors=json[0];
          document.querySelector('.nc_content').value=`${userinfors[1]}`;
          document.querySelector('.tx').style.backgroundImage=`url('http://132.232.99.181:1111/img/userimgs/${userinfors[2]}?t=${new Date()}')`;
          document.querySelector('.userinfo').style.backgroundImage=`url('http://132.232.99.181:1111/img/userimgs/${userinfors[3]}?t=${new Date()}')`;
          document.querySelector('.historySet_set').value=userinfors[4];
          HistorySet=userinfors[4];
          $.ajax({
            url: `http://132.232.99.181:1111/BsHandler.aspx?index=13&key=${userid}`,
            type: 'POST',
            processData: false,
            contentType: false,
            success: function (response) {
              let json=JSON.parse(response);
              let layerbox=document.querySelector('.myGeo');
              layerbox.innerHTML=`
              <div class="myGeo_title">我的图层</div>          
              <div class="myGeo_miniBox" style="display: none;">
                <div class="myGeo_miniView"></div>
                <div class="myGeo_miniName"></div>
                <div></div>
                <div></div>
              </div>`;
              const myGeo_miniBox=document.querySelector('.myGeo_miniBox');
              json.forEach(g=>{
                let geo=g;
                let newLayer=myGeo_miniBox.cloneNode(true);
                newLayer.style.display="flex";
                layerbox.appendChild(newLayer);
                let divs=newLayer.querySelectorAll('div');
                divs[0].id=geo[1];
                GeoList={};
                GeoList[geo[1]]=[geo[1],geo[0]]
                if(geo[2]=="距离"){
                  divs[0].style.backgroundImage="url('http://132.232.99.181:1111/img/L1_ico.png')"
                }
                else if(geo[2]=="面积"){
                  divs[0].style.backgroundImage="url('http://132.232.99.181:1111/img/L2_ico.png')"
                }
                divs[1].innerHTML=geo[1];
                divs[2].classList.add('miniDiv5');
                divs[2].addEventListener('click',function(){
                  let check=false;
                  let minis=document.querySelectorAll('.miniBox');
                  minis.forEach(m=>{
                    if(m.querySelectorAll('div')[1].innerHTML==`{$geo[1]}--[{$geo[2]}]`){
                      check=true;
                    }
                  })
                  if(check){
                    alert('已有同名图层存在！');
                  }
                  else{
                    This.activeSomeEle(divs[2]);
                    let x=restoreLayer(geo[0]);
                    window.outerGraphic=x;
                    graphicList[`${geo[1]}--[${geo[2]}]`]=[];
                    graphicList[`${geo[1]}--[${geo[2]}]`].push(0);
                    x.forEach(l=>{
                      graphicList[`${geo[1]}--[${geo[2]}]`].push(l);
                    })
                    This.ReRenderMapView();
                    alert('成功添加到地图图层');
                  }
                })
  
                divs[3].classList.add('miniDiv6');
                divs[3].addEventListener('click',function(){
                  This.activeSomeEle(divs[3]);
                  user_delGeo(userid,geo[1]);
                })
              })
            }
          })
        }
      }
    })
  }
  //上传geo
  function user_upGeo(id,geojson,name,type){
    var form = new FormData();
    form.append("id", id);
    form.append("geojson", geojson);
    form.append("name", name);
    form.append("type", type);
    $.ajax({
      url: `http://132.232.99.181:1111/BsHandler.aspx?index=15&key=0`,
      type: 'POST',
      data:form,
      processData: false,
      contentType: false,
      success: function (response) {
        user_refresh();
      }
    })
  }
  //删除geo
  function user_delGeo(id,name){
    var form = new FormData();
    form.append("id", id);
    form.append("name", name);
    console.log(id,name);
    $.ajax({
      url: `http://132.232.99.181:1111/BsHandler.aspx?index=16&key=0`,
      type: 'POST',
      data:form,
      processData: false,
      contentType: false,
      success: function (response) {
        user_refresh();
        if(response=="失败"){
          alert("请检查是以保存过同名图层");
        }
      }
    })
  }
  //上传照片
  function user_upImg(id,type,file){
    var form = new FormData();
    form.append("id", id);
    form.append("type", type);
    form.append("file", file);
    $.ajax({
      url: `http://132.232.99.181:1111/BsHandler.aspx?index=17&key=0`,
      type: 'POST',
      data:form,
      processData: false,
      contentType: false,
      success: function (response) {
        if(type=="tx") document.querySelector('.tx').style.backgroundImage=`url('http://132.232.99.181:1111/img/userimgs/${userid}_tx.png?t=${new Date()}')`;
        else document.querySelector('.userinfo').style.backgroundImage=`url('http://132.232.99.181:1111/img/userimgs/${userid}_bg.png?t=${new Date()}')`;
      }
    })
  }
  //更改用户信息
  function user_upUser(id,name,historyset){
    var form = new FormData();
    form.append("id", id);
    form.append("name", name);
    form.append("historyset", historyset);
    $.ajax({
      url: `http://132.232.99.181:1111/BsHandler.aspx?index=18&key=0`,
      type: 'POST',
      data:form,
      processData: false,
      contentType: false,
      success: function (response) {
        user_refresh();
      }
    })
  }

  let ModleType="predict";
  let id=0;
  let data;
  let date=[];
  let IsRun=true;
  let IsRunPN=true;
  let opacityAll=1;
  let ClassColor=['rgb(0.5,153,102)','rgb(255,222,51)','rgb(255,153,51)','rgb(204,0,51)','rgb(102,0,153)','rgb(126,0,35)'];
  let url="http://127.0.0.1:5000/api/handleData";
  let webmap;
  let baseExtent;
  let rasterLayersH=[]; //当前历史栅格集
  let rasterLayersP=[]; //当前预测栅格集
  let pridectMap;
  let rasterNow;
  let R5Raster;
  let rendereringRules;
  let FxRange=`[{"geometry":{"spatialReference":{"latestWkid":3857,"wkid":102100},"rings":[[[11653330.465472333,3703844.6614461034],[11653962.842061587,3703833.25308426],[11654271.602929777,3703719.658879676],[11654321.337587273,3703718.7696458455],[11654347.772190124,3703709.007704304],[11654364.892965445,3703673.0028482797],[11654378.084659712,3703616.1576985177],[11654396.780677315,3703588.709474779],[11654403.874417234,3703558.08147162],[11654389.398472948,3703500.170619686],[11654547.499736236,3703431.2285663886],[11654659.540053604,3703413.374125803],[11655491.006023781,3703280.275248729],[11655462.48259364,3702386.3512388202],[11655403.984205643,3702213.7140105614],[11655390.482416354,3702193.716805451],[11655377.829178616,3702181.3875442506],[11655355.303581063,3702173.2601635507],[11655235.877842465,3702167.664377074],[11655057.269957917,3702154.9961358723],[11654954.113801045,3702143.553899815],[11654882.616819205,3702129.2602180056],[11654821.989074549,3702110.4097124375],[11654752.722325386,3702078.2871829644],[11654698.521729505,3702048.1909070625],[11654611.864724874,3701976.8454658384],[11654429.820835901,3701771.033529474],[11654404.148117421,3701716.3708179775],[11654377.561357098,3701675.276454888],[11654360.134864597,3701669.554667741],[11654257.19589995,3701668.3876120304],[11654239.451957379,3701650.6019683904],[11654195.76793407,3701695.007824109],[11654003.6346304,3701827.956418781],[11653979.295378326,3701838.6374294613],[11653967.511748059,3701842.886650758],[11653868.902985632,3701849.880171259],[11653839.778517669,3701860.6040844154],[11653826.862512017,3701872.3930630563],[11653552.405488849,3702252.143289738],[11653439.82330132,3702499.310482439],[11653391.951758038,3702565.5724796588],[11653385.5799164,3702607.677209755],[11653351.026516398,3702612.2459746664],[11653259.755935455,3702706.659390768],[11653253.353185046,3702726.87532045],[11653253.08982645,3703009.164304397],[11653116.882834096,3703127.7781114345],[11653099.433689117,3703203.5340263513],[11653043.036601182,3703253.2131086914],[11653122.05202953,3703449.6260182383]]],"type":"polygon"},"symbol":{"type":"simple-fill","color":[101,153,131,77],"outline":{"type":"esriSLS","color":[255,116,3,255],"width":2,"style":"esriSLSSolid"},"style":"esriSFSSolid"},"attributes":null}]`;
  let pointsLayer;
  let draw;
  let action;
  let This;
  let graphicList = new Array();
  let graphiIndex=1;
  let graphcAddIndex=1;
  let currentColor;
  let currentKey="";
  let pointsData=[
    ["01",104.688088,31.544095],
    ["02",104.68406,31.541846],
    ["03",104.687663,31.541239],
    ["04",104.691058,31.541],
    ["05",104.69123,31.537396],
    ["06",104.69471,31.540953],
    ["07",104.698317,31.540876],
    ["08",104.702278,31.540689],
    ["09",104.702106,31.536947],
    ["10",104.701907,31.533953],
    ["11",104.698369,31.533531],
    ["12",104.698925,31.537109],
    ["13",104.695699,31.537266],
    ["14",104.695046,31.533274],
    ["15",104.691451,31.531104],
    ["16",104.690902,31.534309],
    ["17",104.687416,31.533868],
    ["18",104.686728,31.537525],
  ]
  const graphicIndex = new Map();//存储点shp
  const pointDataStore = {}; // 存储各点数据 { 点名: { time: '', co2: '' } }
  const jianceDianNodes = {}; // 缓存检测点DOM元素
  //判断PC或移动
  function detectDevice() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/mobile|android|iphone|ipad|tablet/i.test(userAgent)) {
      return "Mobile";
    } 
    else {
      return "PC";
    }
  }
  let MP=detectDevice();
  //叠加图控制
  let relicontrol = {};
  let reliIndex = 0, reliTime;
  Object.defineProperty(relicontrol, 'variable1', {
    get: function() {  
      return reliIndex;
    },
    set: function(newValue) {
      reliIndex = newValue;
    }
  });
  Object.defineProperty(relicontrol, 'variable2', {
    get: function() {
      return reliTime;
    },
    set: function(newValue) {
      reliTime = newValue;
      changeReli();
      ReSet_Echart_datas(This.activeR1);
      ReSet_Echart_lines(This.activeR3);
      ReSet_Echart_areas(This.activeR4);
      setR5(This.activeR5);
    }
  });
  //动态更改值
  function animateValue(targetObj, endValue) {
      const startValue = targetObj.opacity;
      const duration = 500; // 固定0.5秒
      let startTime = null;
  
      function _animate(timestamp) {
          if (!startTime) startTime = timestamp;
          const elapsed = timestamp - startTime;
          const progress = Math.min(elapsed / duration, 1);
          
          // 使用缓动函数让动画更自然
          targetObj.opacity = startValue + (endValue - startValue) * easeInOutQuad(progress);

          if (progress < 1) {
              requestAnimationFrame(_animate);
          }
      }
  
      requestAnimationFrame(_animate);
  }
  // 缓动函数（渐进渐出）
  function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  let calstate=true;
  let topdataMap={};
  let allPixelDatas;
  let allPixelDatasH;
  let allPixelDatasP;
  function settopdatas(nameIndex){
    let topaqi=document.querySelector('.top_aqi');
    let top_datas=document.querySelector('.top_datas').querySelectorAll('td');
    if(topdataMap[nameIndex]!=null){
      let c;
      if(topdataMap[nameIndex][6]<50){c=ClassColor[0]}
      else if(topdataMap[nameIndex][6]<100){c=ClassColor[1]}
      else if(topdataMap[nameIndex][6]<150){c=ClassColor[2]}
      else if(topdataMap[nameIndex][6]<200){c=ClassColor[3]}
      else if(topdataMap[nameIndex][6]<300){c=ClassColor[4]}
      else {c=ClassColor[5]}

      top_datas[0].innerHTML=topdataMap[nameIndex][0];
      top_datas[1].innerHTML=topdataMap[nameIndex][1];
      top_datas[2].innerHTML=topdataMap[nameIndex][2];
      top_datas[3].innerHTML=topdataMap[nameIndex][3];
      top_datas[4].innerHTML=topdataMap[nameIndex][4];
      top_datas[5].innerHTML=topdataMap[nameIndex][5];
      topaqi.innerHTML=`<strong style="color: ${c};font-size:18px;">${topdataMap[nameIndex][6]}</strong>`;
      calstate=false;
      //更改阈值极值
      pixelSlider.min=parseInt(topdataMap[nameIndex][7])-5;
      pixelSlider.max=parseInt(topdataMap[nameIndex][8])+5;
      pixelSlider.values=[pixelSlider.min,pixelSlider.max];
      if(!staticyuzhi){
        yuzhi_control.yuzhiMin=pixelSlider.min;
        yuzhi_control.yuzhiMax=pixelSlider.max;
      }
    }
  }
  function getAndfilterPixel(param, nameIndex) {
    try{
      calstate=true;
      if(topdataMap[nameIndex]!=null){
        settopdatas(nameIndex);
      }
      else{
        if(allPixelDatas!=null){
          let rt=[];
          const names=[`IDW_${nameIndex}_PM2_5`,`IDW_${nameIndex}_PM10`,`IDW_${nameIndex}_AQI`];

          names.forEach(n=>{
            let fr=allPixelDatas.samples.filter(sample => {
              const rasterId = sample.rasterId;
              if(ModleType=="history"){return window.rasterIdToNameH[rasterId] == n;}
              else{return window.rasterIdToNameP[rasterId] == n;}
            });
            rt.push(fr.map(sample => sample.pixelValue[0]));
          })
          if(rt[0].length>1&&rt[1].length>1&&rt[2].length>1){
            topdataMap[nameIndex]=[
              Math.max(...rt[0]).toFixed(2),
              (rt[0].reduce((a, b) => a + b, 0) / rt[0].length).toFixed(2),
              Math.min(...rt[0]).toFixed(2),
              Math.max(...rt[1]).toFixed(2),
              (rt[1].reduce((a, b) => a + b, 0) / rt[1].length).toFixed(2),
              Math.min(...rt[1]).toFixed(2),
              (rt[2].reduce((a, b) => a + b, 0) / rt[2].length).toFixed(0),
              Math.min(...rt[2]).toFixed(0),
              Math.max(...rt[2]).toFixed(0),
            ]
          }
          if(calstate) getAndfilterPixel(param, nameIndex);
        }
        else{
          let rasters=This.mapview.map.findLayerById(`IDW_${reliTime.replace(/-/g, '')}_AQI`);
          rasters.load().then(()=>{
            rasters.getSamples(param).then((results) => {
              allPixelDatas=results;
              if(ModleType=="history"){allPixelDatasH=results;}
              else{allPixelDatasP=results;}
              if(calstate) getAndfilterPixel(param, nameIndex);
            })
            .catch(()=>{
              if(calstate) getAndfilterPixel(param, nameIndex);
            })
          })
        }
      }
    }
    catch{
      if(calstate) {
        setTimeout(() => {
          getAndfilterPixel(param, nameIndex)
        }, 100);
      };
    }
  }
  //热力图控制
  function changeReli(){
    try{
      animateValue(This.mapview.map.findLayerById(`IDW_${reliTime.replace(/-/g, '')}_AQI`), opacityAll);
      if(rasterNow!=null&&rasterNow!=`IDW_${reliTime.replace(/-/g, '')}_AQI`){
        const rn=rasterNow;
        setTimeout(() => {
          animateValue(This.mapview.map.findLayerById(rn), 0);
        }, 200);
      }
      rasterNow=`IDW_${reliTime.replace(/-/g, '')}_AQI`;
    }
    catch{}
    //top数值更改
    const outPolygonGeo = JSON.parse(FxRange)[0].geometry;
    const param = {
      geometry: Polygon.fromJSON(outPolygonGeo),
      returnFirstValueOnly: false,
      // resolution - unit of the view's spatial reference
      pixelSize: {
        x:3,
        y:3,
        spatialReference: This.mapview.spatialReference
      },
      interpolation: "nearest",
      // unit of the geometry's spatial reference is used
      sampleDistance: 30,
      outFields: ["*"]
    };
    let topaqi=document.querySelector('.top_aqi');
    let top_datas=document.querySelector('.top_datas').querySelectorAll('td');
    topaqi.innerHTML="……";
    top_datas.forEach(t=>{
      t.innerHTML="……";
    })

    getAndfilterPixel(param,reliTime.replace(/-/g, ''));
  }

  //统计数据，Echart_datas控制
  // 基于准备好的dom，初始化echarts实例
  var Echart_datas_left;
  var Echart_datas_right;

  //动态监听
  let Echart_datas_control = {};
  let Echart_datas_control_name = '01';
  Object.defineProperty(Echart_datas_control, 'name', {
    get: function() {  
      return Echart_datas_control_name;
    },
    set: function(newValue) {
      const markerSymbol = new SimpleMarkerSymbol({
        color: [226, 119, 40, 0.8],
        outline: {
          color: [255, 255, 255],
          width: 1
        },
        size: "12px"
      });
      graphicIndex.get(Echart_datas_control.name).symbol=markerSymbol;
      document.querySelector('.Echart_datas_date').innerHTML=newValue;
      Echart_datas_control_name = newValue;
      ReSet_Echart_datas(This.activeR1);
    }
  });
  function ReSet_Echart_datas(open) {
    if(open){
      if(Echart_datas_left == null || Echart_datas_right == null){
        Echart_datas_left = echarts.init(document.getElementById('Echart_datas_left'));
        Echart_datas_right = echarts.init(document.getElementById('Echart_datas_right'));
        document.querySelector('.Echart_datas_date').style.opacity=1;
        document.querySelector('.Echart_datas_ControlBox').style.opacity=1;
      }
      const markerSymbol = new SimpleMarkerSymbol({
        color: [39,214,249, 1],
        outline: {
          color: [42,63,252],
          width: 1
        },
        size: "14px"
      });
      const graphic = graphicIndex.get(Echart_datas_control.name);
      graphic.symbol=markerSymbol;
      var key;
      if(ModleType=="history"){
        key=`H,${Echart_datas_control.name}_${reliTime}`;
      }
      else{
        key=`P,${Echart_datas_control.name}`;
      }
      $.ajax({
        url: `http://132.232.99.181:1111/BsHandler.aspx?index=9&key=${key}`,
        type: 'POST',
        processData: false,
        contentType: false,
        success: function (response) {
          let json=JSON.parse(response);
          //左侧
          let EchartleftData=[0,0,0,0,0,0];
          json.forEach(d=>{
            if(d[3]<50){EchartleftData[0]++;}
            else if(d[3]<100){EchartleftData[1]++;}
            else if(d[3]<150){EchartleftData[2]++;}
            else if(d[3]<200){EchartleftData[3]++;}
            else if(d[3]<300){EchartleftData[4]++;}
            else {EchartleftData[5]++;}
          })
          Echart_datas_left.setOption({
            legend: {
              data: ['优','良','轻度','中度','重度','严重'],
              orient: 'vertical',
              itemHeight: 12, // 修改图标高度
              itemWidth: 10,
              x:'left',
              y:'center',
              textStyle: {
                  fontSize: 10, // 字体大小
                  color: '#ffffff' // 字体颜色
                },
            },
            color:ClassColor,
            series: [
              {
                type: 'pie',
                label: {
                  show: false
                },
                data: [
                  {
                    value: EchartleftData[0],
                    name: '优',
                  },
                  {
                    value: EchartleftData[1],
                    name: '良'
                  },
                  {
                    value: EchartleftData[2],
                    name: '轻度'
                  },
                  {
                    value: EchartleftData[3],
                    name: '中度'
                  },
                  {
                    value: EchartleftData[4],
                    name: '重度'
                  },
                  {
                    value: EchartleftData[5],
                    name: '严重'
                  },
                ],
                center: ['65%','40%'],
                radius: ['35%', '60%']
              }
            ]
          });
          //右侧
          let EchartrightData=[[],[],[],[]];
          if(ModleType=="history"){
            json.forEach(item => {
              // 提取时间（格式化为HH:mm）
              const time = item[0].split('_')[1].split('-').slice(3, 5).join(':');
              EchartrightData[0].push(time);
              // 数值转换
              EchartrightData[1].push(parseFloat(item[1]));
              EchartrightData[2].push(parseFloat(item[2]));
              EchartrightData[3].push(parseFloat(item[3]));
            });
          }
          else{
            for(var i=0;i<=json.length;i++){
              // 提取时间（格式化为HH:mm）
              if(i!=1&&i!=json.length){
                const time = pridectMap[json[i][0].split('_')[1]];
                EchartrightData[0].push(time);
                // 数值转换
                EchartrightData[1].push(parseFloat(json[i][1]));
                EchartrightData[2].push(parseFloat(json[i][2]));
                EchartrightData[3].push(parseFloat(json[i][3]));
              }
              if(i==json.length){
                const time = pridectMap[json[1][0].split('_')[1]];
                EchartrightData[0].push(time);
                // 数值转换
                EchartrightData[1].push(parseFloat(json[1][1]));
                EchartrightData[2].push(parseFloat(json[1][2]));
                EchartrightData[3].push(parseFloat(json[1][3]));
              }
            };
          }
          // 绘制图表
          Echart_datas_right.setOption({
            grid:{
              top:30,
              bottom:30,
              left:30,
              right:10,
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross'
              }
            },
            legend: {
              data: ['PM2.5', 'PM10', 'AQI'],
              top: 2,
              textStyle: {
                  fontSize: 10, // 字体大小
                  color: '#ffffff' // 字体颜色
                },
            },
            xAxis: {
              type: 'category',
              data: EchartrightData[0],
              axisLabel: {
                rotate: 45,  // 标签旋转45度防止重叠
                interval: 3,              
                textStyle: {
                  fontSize: 6, // 字体大小
                  color: '#ffffff' // 字体颜色
                },
              },
            },
            yAxis: {
              type: 'value',
              name: '浓度/指标',
              nameTextStyle: {
                color: '#ffffff',
                fontSize: 9
              },
              nameLocation: "middle",
              nameGap: 20,
              min: 0,
              axisLabel: {           
                textStyle: {
                  fontSize: 8, // 字体大小
                  color: '#ffffff' // 字体颜色
                },
              },
            },
            series: [
              {
                name: 'PM2.5',
                type: 'line',
                data: EchartrightData[1],
                smooth: true,
                itemStyle: {
                  color: '#5470C6'  // 线条颜色
                },
                areaStyle: {
                  color: {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [{
                      offset: 0, color: 'rgba(84, 112, 198, 0.6)'  // 渐变填充
                    }, {
                      offset: 1, color: 'rgba(84, 112, 198, 0)'
                    }]
                  }
                }
              },
              {
                name: 'PM10',
                type: 'line',
                data: EchartrightData[2],
                smooth: true,
                itemStyle: {
                  color: '#91CC75'  // 线条颜色
                },
                areaStyle: {
                  color: {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [{
                      offset: 0, color: 'rgba(145, 204, 117, 0.6)'
                    }, {
                      offset: 1, color: 'rgba(145, 204, 117, 0)'
                    }]
                  }
                }
              },
              {
                name: 'AQI',
                type: 'line',
                data: EchartrightData[3],
                smooth: true,
                itemStyle: {
                  color: '#EE6666'  // 红色线条
                },
                lineStyle: {
                  width: 2
                }
              }
            ]
          });
        }
      })
    }
  }
  //Echart_lines、Echart_areas监听
  //动态监听
  let Echart_linearea_control = {};
  let Echart_linearea_control_linename,Echart_linearea_control_areaname;
  Object.defineProperty(Echart_linearea_control, 'linename', {
    get: function() {  
      return Echart_linearea_control_linename;
    },
    set: function(newValue) {
      Echart_linearea_control_linename = newValue;
      ReSet_Echart_lines(This.activeR3);
    }
  });
  Object.defineProperty(Echart_linearea_control, 'areaname', {
    get: function() {  
      return Echart_linearea_control_areaname;
    },
    set: function(newValue) {
      Echart_linearea_control_areaname = newValue;
      ReSet_Echart_areas(This.activeR4);
    }
  });
  let Echart_lines_left;
  let Echart_areas_left;
  let Echart_areas_right;

  let allPixelDatas_line={};
  let Echartoptions_line={};
  let calstate_line=false;
  function getAndfilterPixel_line(linename, param, nameIndex) {
    try{
      calstate_line=true;
      if(Echartoptions_line[`${linename}${nameIndex}`]!=null){
        document.querySelector('.Echart_lines').querySelector('.tishi').style.opacity=0;
        document.querySelector('.Echart_lines_left').style.opacity=1;
        console.log('1');
        Echart_lines_left.setOption(Echartoptions_line[`${linename}${nameIndex}`]);
        calstate_line=false;
      }
      else{
        if(allPixelDatas_line[`${linename}`]!=null){
          console.log('2');
          let rt=[];
          const names=[`IDW_${nameIndex}_PM2_5`,`IDW_${nameIndex}_PM10`,`IDW_${nameIndex}_AQI`];
          names.forEach(n=>{
            let fr=allPixelDatas_line[`${linename}`][0].samples.filter(sample => {
              const rasterId = sample.rasterId;
              if(ModleType=="history"){return window.rasterIdToNameH[rasterId] === n;}
              else{return window.rasterIdToNameP[rasterId] === n;}
            });
            rt.push(fr.map(sample => [sample.location.latitude,sample.location.longitude,sample.pixelValue[0]]));
          })
          function soption(d) {
            let EchartrightData=[[],[],[],[],[]];
            let xindex={};
            for(var i=0;i<d[0].length;i++){
              EchartrightData[0].push(i);
              EchartrightData[1].push(d[0][i][2]);
              xindex[i]=d[0][i][0];
            }

            EchartrightData[0].forEach(d=>{
              EchartrightData[4].push(`${(d / (EchartrightData[0].length-1)*100).toFixed(0)}%`);
            })
            d[1].forEach(item => {
              EchartrightData[2].push(item[2]);
            });
            d[2].forEach(item => {
              EchartrightData[3].push(item[2]);
            });

            return {
              grid:{
                top:30,
                bottom:30,
                left:35,
                right:10,
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'cross'
                }
              },
              legend: {
                data: ['PM2.5', 'PM10', 'AQI'],
                top: 2,
                textStyle: {
                    fontSize: 10, // 字体大小
                    color: '#ffffff' // 字体颜色
                  },
              },
              xAxis: {
                type: 'category',
                data: EchartrightData[4],
                axisLabel: {
                  textStyle: {
                    fontSize: 10, // 字体大小
                    color: '#ffffff' // 字体颜色
                  },
                  show: true, 
                  rotate: 0,
                  formatter: (value)=> {
                    if(value=='0%'){return '起点';}
                    else {return value;}
                  },
                },
              },
              yAxis: {
                type: 'value',
                name: '浓度/指标',
                nameTextStyle: {
                  color: '#ffffff',
                  fontSize: 9
                },
                nameLocation: "middle",
                nameGap: 20,
                min: 0,
                axisLabel: {           
                  textStyle: {
                    fontSize: 8, // 字体大小
                    color: '#ffffff' // 字体颜色
                  },
                },
              },
              series: [
                {
                  name: 'PM2.5',
                  type: 'line',
                  data: EchartrightData[1],
                  smooth: true,
                  itemStyle: {
                    color: '#5470C6'  // 线条颜色
                  },
                  areaStyle: {
                    color: {
                      type: 'linear',
                      x: 0, y: 0, x2: 0, y2: 1,
                      colorStops: [{
                        offset: 0, color: 'rgba(84, 112, 198, 0.6)'  // 渐变填充
                      }, {
                        offset: 1, color: 'rgba(84, 112, 198, 0)'
                      }]
                    }
                  }
                },
                {
                  name: 'PM10',
                  type: 'line',
                  data: EchartrightData[2],
                  smooth: true,
                  itemStyle: {
                    color: '#91CC75'  // 线条颜色
                  },
                  areaStyle: {
                    color: {
                      type: 'linear',
                      x: 0, y: 0, x2: 0, y2: 1,
                      colorStops: [{
                        offset: 0, color: 'rgba(145, 204, 117, 0.6)'
                      }, {
                        offset: 1, color: 'rgba(145, 204, 117, 0)'
                      }]
                    }
                  }
                },
                {
                  name: 'AQI',
                  type: 'line',
                  data: EchartrightData[3],
                  smooth: true,
                  itemStyle: {
                    color: '#EE6666'  // 红色线条
                  },
                  lineStyle: {
                    width: 2
                  }
                }
              ]
            };
          }

          Echartoptions_line[`${linename}${nameIndex}`]=soption(rt);
          if(calstate_line) getAndfilterPixel_line(linename,param, nameIndex);
        }
        else{
          console.log('3');
          let rasters=This.mapview.map.findLayerById(`IDW_${reliTime.replace(/-/g, '')}_PM2_5`);
          rasters.load().then(()=>{
            rasters.getSamples(param).then((results) => {
              let biaoji=[];
              graphicList[linename].forEach(g=>{
                if(g!=0 && g.symbol.type=="text"){
                  biaoji.push([g.geometry.latitude,g.geometry.longitude,g.symbol.text]);
                }
              })
              allPixelDatas_line[`${linename}`]=[results,biaoji];
              if(calstate_line) getAndfilterPixel_line(linename,param, nameIndex);
            })
            .catch(()=>{
              if(calstate_line) getAndfilterPixel_line(linename,param, nameIndex);
            })
          })
        }
      }
    }
    catch(error){
      console.log(error);
      if(!calstate_line) getAndfilterPixel_line(linename,param, nameIndex);
    }
  }
  function ReSet_Echart_lines(open) {
    if(open){
      if(Echart_linearea_control_linename != null){
        if(Echart_lines_left==null){
          Echart_lines_left = echarts.init(document.querySelector('.Echart_lines_left'));
        }
        if(graphicList[Echart_linearea_control_linename]!=null){
          const param = {
            geometry: graphicList[Echart_linearea_control_linename][1].geometry,
            returnFirstValueOnly: false,
            // resolution - unit of the view's spatial reference
            pixelSize: {
              x:3,
              y:3,
              spatialReference: This.mapview.spatialReference
            },
            interpolation: "nearest",
            // unit of the geometry's spatial reference is used
            sampleDistance: 30,
            outFields: ["*"]
          };
          document.querySelector('.Echart_lines').querySelector('.tishi').innerHTML="…………";
          getAndfilterPixel_line(Echart_linearea_control_linename,param,reliTime.replace(/-/g, ''));
        }
        else{
          document.querySelector('.Echart_lines').querySelector('.tishi').innerHTML=`请从图层选择线--可利用“距离测量”工具添加线`;
          document.querySelector('.Echart_lines').querySelector('.tishi').style.opacity=1;
          document.querySelector('.Echart_lines_left').style.opacity=0;
        }
      }
    }
  }
  let allPixelDatas_area={};
  let Echartoptions_area={};
  let calstate_area=false;
  let staticyuzhi=false;
  function getAndfilterPixel_area(areaname, param, nameIndex) {
    try{
      calstate_area=true;
      if(Echartoptions_area[`${areaname}${nameIndex}`]!=null){
        document.querySelector('.Echart_areas').querySelector('.tishi').style.opacity=0;
        document.querySelectorAll('.Echart_areas_font').forEach(e=>{
          e.style.opacity=1;
        })
        document.querySelector('.Echart_areas_left').style.opacity=1;
        document.querySelector('.Echart_areas_right').style.opacity=1;
        Echart_areas_left.setOption(Echartoptions_area[`${areaname}${nameIndex}`][2][0]);
        Echart_areas_right.setOption(Echartoptions_area[`${areaname}${nameIndex}`][2][1]);
        calstate_area=false;
      }
      else{
        if(allPixelDatas_area[`${areaname}`]!=null){
          let rt=[];
          const names=[`IDW_${nameIndex}_PM2_5`,`IDW_${nameIndex}_PM10`,`IDW_${nameIndex}_AQI`];
          names.forEach(n=>{
            let fr=allPixelDatas_area[`${areaname}`].samples.filter(sample => {
              const rasterId = sample.rasterId;
              if(ModleType=="history"){return window.rasterIdToNameH[rasterId] === n;}
              else{return window.rasterIdToNameP[rasterId] === n;}
            });
            rt.push(fr.map(sample => [sample.location.latitude,sample.location.longitude,sample.pixelValue[0]]));
          })
          function soption(d,type) {
            // 提取 x/y 值的范围
            const xValues = d.map(item => item[0]);
            const yValues = d.map(item => item[1]);
            
            // 计算最小最大值（处理空数据兜底）
            let xMin = Math.min(...xValues) ?? 0;
            let xMax = Math.max(...xValues) ?? 1;
            let yMin = Math.min(...yValues) ?? 0;
            let yMax = Math.max(...yValues) ?? 1;
            const dx=xMax-xMin;
            const dy=yMax-yMin;
            xMin-=dx/15;
            xMax+=dx/15;
            yMin-=dy/10;
            yMax+=dy/10;
            // Step 1: 按 x 值分组，计算 y 的均值
            let dmap={};
            d.forEach(dd=>{
              if(dmap[dd[0]]==null){
                dmap[dd[0]]=[0,0];
              }
              else{
                dmap[dd[0]][0]++;
                dmap[dd[0]][1]+=dd[1];
              }
            })
            const lineData=[];
            for(var key in dmap){
              lineData.push([key,dmap[key][1]/dmap[key][0]]);
            }
            lineData.sort((a, b) => a[0] - b[0]);
            return {
              grid: {
                top: 40,
                bottom: 25,
                left: 26,
                right: 20,
              },
              title: {
                text:  `${type[0]}-${type[1]}向趋势`,
                top:2,
                x:'center',
                textStyle: {
                  fontSize: 10, // 字体大小
                  color: '#ffffff' // 字体颜色
                },
              },
              xAxis: {
                min: xMin,
                max: xMax,
                axisLabel: {
                  textStyle: {
                    fontSize: 8, // 字体大小
                    color: '#ffffff' // 字体颜色
                  },
                  show: true, // 强制显示轴标签
                  // 只在最小/最大值位置显示文字
                  formatter: (value) => {
                    return ''; // 其他位置不显示标签
                  }
                },
                axisTick: {
                  show: false // 隐藏刻度线
                },
                splitLine: {
                  show: false // 隐藏网格线
                }
              },
              yAxis: {
                min: yMin,
                max: yMax,
                // 保持默认标签显示
                axisLabel: {           
                  textStyle: {
                    fontSize: 8, // 字体大小
                    color: '#ffffff' // 字体颜色
                  },
                  
                  formatter: (value) => {
                    if (value === yMin) return parseInt(yMin); // 最小值显示"西"
                    if (value === yMax) return Math.ceil(yMax); // 最大值显示"东"
                    return value; // 其他位置不显示标签
                  }
                },
                splitLine: {
                  show: false // 隐藏网格线
                }
              },
              legend: {
                data: ['值', '趋势线'],
                top: 14,
                textStyle: {
                    fontSize: 10, // 字体大小
                    color: '#ffffff' // 字体颜色
                  },
                  symbolSize:8,
              },
              series: [
                {
                  name:'值',
                  type: 'scatter',
                  data: d,
                },
                // 均值折线图
                {
                  name:'趋势线',
                  type: 'line',
                  data: lineData,
                  symbol: 'circle',       // 显示数据点符号
                  symbolSize: 10,
                  itemStyle: { 
                    color: '#f16',
                  }, // 折线颜色
                  lineStyle: { width: 2 },
                  smooth: true            // 平滑曲线
                }
              ]
            };
          }
          Echartoptions_area[`${areaname}${nameIndex}`]=[];
          rt.forEach(r=>{
            let d1=[];
            let d2=[];
            r.forEach(a=>{
              d1.push([a[0],a[2]]);
              d2.push([a[1],a[2]]);
            });
            Echartoptions_area[`${areaname}${nameIndex}`].push([soption(d1,['南','北']),soption(d2,['西','东'])]);
          })
          if(calstate_area) getAndfilterPixel_area(areaname,param, nameIndex);
        }
        else{
          let rasters=This.mapview.map.findLayerById(`IDW_${reliTime.replace(/-/g, '')}_PM2_5`);
          rasters.load().then(()=>{
            rasters.getSamples(param).then((results) => {
              allPixelDatas_area[`${areaname}`]=results;
              if(calstate_area) getAndfilterPixel_area(areaname,param, nameIndex);
            })
            .catch(()=>{
              if(calstate_area) getAndfilterPixel_area(areaname,param, nameIndex);
            })
          })
        }
      }
    }
    catch{
      if(!calstate_area) getAndfilterPixel_area(areaname,param, nameIndex);
    }
  }
  function ReSet_Echart_areas(open) {
    if(open){
      if(Echart_linearea_control_areaname != null){
        if(Echart_areas_left==null){
          Echart_areas_left = echarts.init(document.querySelector('.Echart_areas_left'));
        }
        if(Echart_areas_right==null){
          Echart_areas_right = echarts.init(document.querySelector('.Echart_areas_right'));
        }
        if(graphicList[Echart_linearea_control_areaname]!=null){
          const param = {
            geometry: graphicList[Echart_linearea_control_areaname][1].geometry,
            returnFirstValueOnly: false,
            // resolution - unit of the view's spatial reference
            pixelSize: {
              x:3,
              y:3,
              spatialReference: This.mapview.spatialReference
            },
            interpolation: "nearest",
            // unit of the geometry's spatial reference is used
            sampleDistance: 30,
            outFields: ["*"]
          };
          document.querySelector('.Echart_areas').querySelector('.tishi').innerHTML="…………";
          getAndfilterPixel_area(Echart_linearea_control_areaname,param,reliTime.replace(/-/g, ''));
        }
        else{
          document.querySelector('.Echart_areas').querySelector('.tishi').innerHTML=`请从图层选择面--可利用“面积测量”工具添加面`;
          document.querySelector('.Echart_areas').querySelector('.tishi').style.opacity=1;
          document.querySelector('.Echart_areas_left').style.opacity=0;
          document.querySelector('.Echart_areas_right').style.opacity=0;
          document.querySelectorAll('.Echart_areas_font').forEach(e=>{
            e.style.opacity=0;
          })
        }
      }
    }
  }
  let pixelSlider;
  let currentMin=70, currentMax=1000;
  let yuzhi_control = {};
  Object.defineProperty(yuzhi_control, 'yuzhiMin', {
    get: function() {  
      return currentMin;
    },
    set: function(newValue) {
      currentMin = newValue;
      setR5(This.activeR5);
    }
  });
  Object.defineProperty(yuzhi_control, 'yuzhiMax', {
    get: function() {  
      return currentMax;
    },
    set: function(newValue) {
      currentMax = newValue;
      setR5(This.activeR5);
    }
  });
  Object.defineProperty(yuzhi_control, 'R', {
    get: function() {  
      return R5R;
    },
    set: function(newValue) {
      R5R = newValue;
      setR5(This.activeR5);
    }
  });
  Object.defineProperty(yuzhi_control, 'G', {
    get: function() {  
      return R5G;
    },
    set: function(newValue) {
      R5G = newValue;
      setR5(This.activeR5);
    }
  });
  Object.defineProperty(yuzhi_control, 'B', {
    get: function() {  
      return R5B;
    },
    set: function(newValue) {
      R5B = newValue;
      setR5(This.activeR5);
    }
  });
  function maskPixels(pixelData) {
    if (pixelData == null || pixelData.pixelBlock == null) {
      return;
    }
    // The pixelBlock stores the values of all pixels visible in the view
    const pixelBlock = pixelData.pixelBlock;
    // The pixels visible in the view
    const pixels = pixelBlock.pixels;
    let mask = pixelBlock.mask;
    // The number of pixels in the pixelBlock
    const numPixels = pixelBlock.width * pixelBlock.height;
    // Get the min and max values of the data in the current view
    // const minVal = pixelData.pixelBlock.statistics[0].minValue;
    // const maxVal = pixelData.pixelBlock.statistics[0].maxValue;
    // // Calculate the factor by which to determine the red and blue
    // // values in the colorized version of the layer
    // const factor = 255.0 / (maxVal - minVal);
    // if (pixels == null) {
    //   return;
    // }
    // Get the pixels containing temperature values in the only band of the data
    const tempBand = pixels[0];
    const p1 = pixels[0];
    // Create empty arrays for each of the RGB bands to set on the pixelBlock
    const rBand = new Uint8Array(p1.length);
    const gBand = new Uint8Array(p1.length);
    const bBand = new Uint8Array(p1.length);
    if (mask == null) {
      mask = new Uint8Array(p1.length); //mask = new Uint8Array(p1.length);
      mask.fill(1);
      pixelBlock.mask = mask;
    }
    // Loop through all the pixels in the view
    let x=0;
    for (let i = 0; i < numPixels; i++) {
      // skip noData pixels
      if (mask[i] === 0) {
        continue;
      }
      const tempValue = tempBand[i];
      // const red = (tempValue - minVal) * factor;
      mask[i] = 2*p1[i] >= Math.floor(currentMin) && 2*p1[i] <= Math.floor(currentMax) ? 1 : 0;
      //apply color based on temperature value of each pixel
      if (mask[i]) {
        // p[i] = Math.floor((p1[i] - minVal) * factor);
        //rBand[i] = red;
        rBand[i] = R5R;
        gBand[i] = R5G;
        bBand[i] = R5B;
      }
    }

    // Set the new pixel values on the pixelBlock
    pixelData.pixelBlock.pixels = [rBand, gBand, bBand]; //assign rgb values to each pixel
    pixelData.pixelBlock.statistics = null;
    pixelData.pixelBlock.pixelType = "u8";
  }
  let yuzhiList={};
  let R5R=255,R5G=0,R5B=0;
  function changeyuzhiLayer(index) {
    if(yuzhiList[index]==null){
      //This.mapview.map.findLayerById(`IDW_${date[index][0].replace(/-/g, '')}_AQI`).pixelFilter=null;
      This.mapview.map.findLayerById(`IDW_${date[index][0].replace(/-/g, '')}_AQI`).renderingRule.functionName="AQI_510";
      This.mapview.map.findLayerById(`IDW_${date[index][0].replace(/-/g, '')}_AQI`).pixelFilter=maskPixels;
    }
    This.mapview.map.findLayerById(`IDW_${date[index][0].replace(/-/g, '')}_AQI`).redraw();
  }
  //阈值查询相关
  function setR5(check){
    if(check){
      //const stretchFunction = new RasterFunction({
      //functionName: "Stretch",
      //  functionArguments: {
      //    StretchType: 5, // (0 = None, 3 = StandardDeviation, 4 = Histogram Equalization, 5 = MinMax, 6 = PercentClip, 9 = Sigmoid)
      //    Min: 0,
      //    Max: 255,
      //    Raster: "$$" // $$(default) refers to the entire image service, $2 refers to the second image of the image service
      //  },
      //  outputPixelType: "u8"
      //});
      //
      //const colorFunction = new RasterFunction({
      //  functionName: "Colormap",
      //  functionArguments: {
      //    ColorrampName: "Temperature", // other examples: "Slope", "Surface", "Blue Bright"....
      //    Raster: stretchFunction // chaining multiple raster functions
      //  }
      //});
      //// 创建色带
      ////function createColorRamp() {
      ////  return new AlgorithmicColorRamp({
      ////    algorithm: "cie-lab",
      ////    fromColor: new Color([255, 255, 255, 0]),
      ////    toColor: new Color([255, 0, 0, 1]),
      ////  });
      ////}
      //function createColorRamp() {
      //  return  new AlgorithmicColorRamp({
      //    algorithm: "cie-lab",
      //    fromColor: new Color([255, 255, 255, 0]),
      //    toColor: new Color([255, 0, 0, 1]),
      //  })
      //}
      //
      //function createRenderer() {
      //  return new RasterStretchRenderer({
      //    colorRamp: createColorRamp(),
      //    stretchType: "min-max",
      //    minPercent: 80,
      //    // 关键：启用 Alpha 通道处理
      //    gamma: [1],            // 伽马校正
      //    useDynamicRange: true,
      //    dra: true,             // 动态范围调整
      //    bandIds: [0],          // 使用第一个波段
      //    outputMax: 255,
      //    outputMin: 0,
      //    outputValues: [null]       // 背景设为透明
      //  });
      //}
      //This.mapview.map.findLayerById(`IDW_2025412_AQI`).pixelFilter = (pixelData) => {
      //  console.log(pixelData);
      //  //const minValue = 0; // 最小像元值（需根据数据范围调整）
      //  //const maxValue = 100;
      //  //for (let i = 0; i < pixelData.length; i++) {
      //  //  const value = pixelData[i][4]; // 第5个元素是栅格值
      //  //  // 计算透明度（基于值范围）
      //  //  const alpha = (value - minValue) / (maxValue - minValue);
      //  //  pixelData[i][3] = alpha * 255; // Alpha 通道（0-255）
      //  //}
      //  //return pixelData;
      //};
      let index=0;
      for(var i=0;i<date.length;i++){
        if(date[i][0]==reliTime){index=i;}
      }
      changeyuzhiLayer(index);
      if(index==date.length-1){
        changeyuzhiLayer(0);
      }
      else{
        changeyuzhiLayer(index+1);
      }
    }
    else{
      //date.forEach(d=>{
      //  This.mapview.map.findLayerById(`IDW_${d[0].replace(/-/g, '')}_AQI`).pixelFilter=null;
      //  //This.mapview.map.findLayerById(`IDW_${d[0].replace(/-/g, '')}_AQI`).renderingRule=rendereringRules;
      //})
    }
  }

  // 时间格式化函数（解决时区问题）
  function getLocalTimeString() {
    const d = new Date();
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .substr(11, 8);
  }
  // 初始化数据存储
  function initDataStore() {
    pointsData.forEach(([name]) => {
      pointDataStore[name] = {
        time: "", // 初始化为当前时间
        co2: ''
      };
    });
  }
  initDataStore();
  
  // 将单个 Graphic 转为 JSON
  function graphicToStorage(graphic) {
    let geometryWithType = {
      ...graphic.geometry.toJSON(),
      type: graphic.geometry.type
    };
    let symbolWithType = {
      ...graphic.symbol.toJSON(),
      type: graphic.symbol.type
    };

    return {
      geometry: geometryWithType,  // 几何数据
      symbol: symbolWithType,     // 符号数据
      attributes: graphic.attributes       // 属性数据
    };
  }

  // 重建Graphic
  function storageToGraphic(data) {
    let geometry;
    switch(data.geometry.type) {
      case 'point':
        geometry = Point.fromJSON(data.geometry);
        break;
      case 'polyline':
        geometry = Polyline.fromJSON(data.geometry);
        break;
      case 'polygon':
        geometry = Polygon.fromJSON(data.geometry);
        break;
    }
    let symbol;
    switch(data.symbol.type) {
      case 'simple-marker':
        symbol = SimpleMarkerSymbol.fromJSON(data.symbol);
        break;
      case 'simple-line':
        symbol = SimpleLineSymbol.fromJSON(data.symbol);
        break;
      case 'simple-fill':
        symbol = SimpleFillSymbol.fromJSON(data.symbol);
        break;
      case 'text':
        symbol = TextSymbol.fromJSON(data.symbol);
        break;
    }

    return new Graphic({
      geometry:geometry,
      symbol:symbol,
      attributes: data.attributes
    });
  }

  // 批量恢复
  function restoreLayer(JsonStr) {
    const jMap = JSON.parse(JsonStr);
    let x=[]
    jMap.forEach(map=>{
      x.push(storageToGraphic(map));
    })
    return x;
  }
  async function ajaxRequest({data = null, key}) {
    try {
      const response = await axios({
       method: data ? 'post' : 'get',
       url: url,
       params: {key: key},
       data: data
      });
      return response.data;
    } catch (error) {
      return {status: 'error', message: error.message};
    }
  }

  //加载栅格
  function getRasterLayer(time,type) {
    //return new MapImageLayer({
    let name=[`IDW_${time}_AQI`,`IDW_${time}_PM2_5`,`IDW_${time}_PM10`];
    let typeA='';
    if(type=='H'){typeA="XqHistory";}
    else{typeA="XqPredict";}
    //    url: "http://132.232.99.181:80/arcgis/rest/services/BsShow/Rasters/MapServer",
    //    sublayers: [{
    //        id: 1,
    //        visible: true,
    //        title: "rasterShow",
    //        source: {
    //            type: "data-layer",
    //            dataSource: {
    //                type: "raster",
    //                workspaceId: "rasters", //服务上的ID
    //                dataSourceName: name //对应文件名字  如果注册文件夹中还有文件夹则需要将嵌套文件夹名字也要写入
    //            }
    //        },
    //    }]
    //});

    //let renderer0 = new RasterStretchRenderer();
    //    renderer0.statistics = [
    // [0, 100, 50, 10] // [<min>, <max>, <mean>, <standardDeviation>]
    //];
    //// 创建色带
    //function createColorRamp() {
    //  return new AlgorithmicColorRamp({
    //    algorithm: "cie-lab",
    //    fromColor: new Color(startColor),
    //    toColor: new Color(endColor)
    //  });
    //}
    //// 创建栅格渲染器
    //function createRenderer() {
    //  return new RasterStretchRenderer({
    //    
    //    colorRamp: createColorRamp(),
    //    stretchType: "min-max", // 根据数据范围拉伸
    //    gamma: [1],            // 伽马校正
    //    useDynamicRange: true,
    //    dra: true,             // 动态范围调整
    //    bandIds: [0],          // 使用第一个波段
    //    outputMax: 255,
    //    outputMin: 0,
    //    outputValues: [null]       // 背景设为透明
    //  });
    //}
    //let colors = [];
    //for (let i = 0; i <= 250; i++) {
    //  if (i < 200) {
    //    colors.push([i, 250, 0, 128]);
    //  } else {
    //    colors.push([i, 0, 128, 250]);
    //  }
    //}
    // 
    //
    //const stretchFunction = new RasterFunction({
    //functionName: "Stretch",
    //  functionArguments: {
    //    StretchType: 5, // (0 = None, 3 = StandardDeviation, 4 = Histogram Equalization, 5 = MinMax, 6 = PercentClip, 9 = Sigmoid)
    //    Min: 0,
    //    Max: 255,
    //    Raster: "$$" // $$(default) refers to the entire image service, $2 refers to the second image of the image service
    //  },
    //  outputPixelType: "u8"
    //});
    //
    //
    //const mosaicRule = new MosaicRule({
    //          ascending: true,
    //          method: "center",
    //          operation: "last"
    //        });
    //const remapRF = new RasterFunction({
    //  functionName: "Remap",
    //  functionArguments: {
    //    // pixel values of forest categories are 41, 42, and 43
    //    // according to the  raster attribute table.
    //    // The InputRanges property defines the ranges of initial pixel values to remap
    //    // Three ranges: [0, 41], [41, 44], and [44, 255] are defined to extract forest pixels.
    //    inputRanges: [0, 41, 41, 44, 44, 255],
    //    // non-forest pixels (0-41 and 44-255) are remapped to a value of 1,
    //    // forest pixels (41-44) are remapped to a value of 2.
    //    outputValues: [1, 2, 1],
    //    // $$(default) refers to the entire image service,
    //    // $2 refers to the second image of the image service
    //    raster: "$$"
    //  }
    //});
    //
    //// The Colormap raster function adds color to each pixel
    //// based on its pixel value
    //const colorRF = new RasterFunction({
    //  functionName: "Colormap",
    //  functionArguments: {
    //    colormap: [
    //      // non-forest pixels (value of 1) are assigned
    //      // a yellowish color RGB = [253, 254, 152]
    //      [1, 253, 254, 152],
    //      // forest pixels (value of 2) are assigned
    //      // a greenish color RGB = [2, 102, 6]
    //      [2, 2, 102, 6]
    //    ],
    //    // Setting the previous raster function to the Raster
    //    // property of a new raster function allows you to chain functions
    //    raster: remapRF
    //  },
    //  outputPixelType: "U8"
    //});
    return [
      new ImageryLayer({
        id:`${name[0]}`,
        url: `http://132.232.99.181:1212/arcgis/rest/services/BsShow/${typeA}/ImageServer`,
        definitionExpression: `NAME = '${name[0]}'`,
        opacity:0,
      }),
      new ImageryLayer({
        id:`${name[1]}`,
        url: `http://132.232.99.181:1212/arcgis/rest/services/BsShow/${typeA}/ImageServer`,
        definitionExpression: `NAME = '${name[1]}'`,
        opacity:0,
      }),
      new ImageryLayer({
        id:`${name[2]}`,
        url: `http://132.232.99.181:1212/arcgis/rest/services/BsShow/${typeA}/ImageServer`,
        definitionExpression: `NAME = '${name[2]}'`,
        opacity:0,
      }),
    ];
  }

  export default {
    name: 'Home',
    components: {
      buttons, // 注册 buttonLeft 组件
      loginpage
    },
    data() {
      return {
        theme: "",
        mapview: "",
        activeButton: null,
        activeBaseMap:'hybrid',
        regionMap:null,
        activeL1:false,
        activeL2:false,
        activeL3:false,
        activeL4:false,
        activeR1:false,
        activeR2:false,
        activeR3:false,
        activeR4:false,
        activeR5:false,
        activeB1:false,
        addDistance:false,
        addArea:false,
        responseData:"",
      };
    },
    mounted() {
      //历史
      // 镶嵌数据集的服务URL（替换为实际URL）
      const imageServiceUrl = "http://132.232.99.181:1212/arcgis/rest/services/BsShow/XqHistory/ImageServer";
      
      // 查询所有栅格的 OBJECTID 和 NAME 字段
      const queryUrl = `${imageServiceUrl}/query`;
      const params = {
        where: "1=1", // 查询所有记录
        outFields: "OBJECTID, Name", // 返回字段
        f: "json", // 返回格式
        returnGeometry: false // 不需要几何信息
      };
      
      // 发送查询请求
      fetch(queryUrl + "?" + new URLSearchParams(params))
        .then(response => response.json())
        .then(data => {
          // 创建 rasterId -> NAME 的映射表
          const rasterIdToName = {};
          data.features.forEach(feature => {
            rasterIdToName[feature.attributes.OBJECTID] = feature.attributes.Name;
          });
          // 保存到全局变量供后续使用
          window.rasterIdToNameH = rasterIdToName;
        })
        .catch(error => console.error("属性查询失败:", error));
      
      //预测
        // 镶嵌数据集的服务URL（替换为实际URL）
      const imageServiceUrl2 = "http://132.232.99.181:1212/arcgis/rest/services/BsShow/XqPredict/ImageServer";
      
      // 查询所有栅格的 OBJECTID 和 NAME 字段
      const queryUrl2 = `${imageServiceUrl2}/query`;
      const params2 = {
        where: "1=1", // 查询所有记录
        outFields: "OBJECTID, Name", // 返回字段
        f: "json", // 返回格式
        returnGeometry: false // 不需要几何信息
      };
      
      // 发送查询请求
      fetch(queryUrl2 + "?" + new URLSearchParams(params2))
        .then(response => response.json())
        .then(data => {
          // 创建 rasterId -> NAME 的映射表
          const rasterIdToName = {};
          data.features.forEach(feature => {
            rasterIdToName[feature.attributes.OBJECTID] = feature.attributes.Name;
          });
          // 保存到全局变量供后续使用
          window.rasterIdToNameP = rasterIdToName;
        })
        .catch(error => console.error("属性查询失败:", error));


      this.loadArcgisMap();
      This=this;
      currentColor=this.getRandomBrightColor();
      this.ActiveDistanceTool();
      this.ActiveAreaTool();

      let historyBtn=document.querySelector('.historyBtn');
      let pridectBtn=document.querySelector('.pridectBtn');
      let resizeObserver;
      //时间条跟随
      function listenTimeline(timeline){
        // 获取元素引用
        let timelineBox = document.querySelector('.timelineBox');
        const timeline0 = document.querySelector('.timeline');
        // 创建观察器监听timeline宽度变化
        resizeObserver = new ResizeObserver(entries => {
          const timelineWidth = entries[0].contentRect.width;
          const containerWidth = timelineBox.clientWidth;
          // 计算可滚动最大距离
          const maxScroll = timelineBox.scrollWidth - containerWidth;
          // 根据timeline宽度百分比计算滚动位置
          const progress = timelineWidth / timeline0.clientWidth;
          timelineBox.scrollLeft = maxScroll * progress;
        });
        // 开始观察timeline元素
        resizeObserver.observe(timeline);
        // 初始化时强制触发一次计算
        timelineBox.scrollLeft = 0;
      }

      // 创建弹窗模板
      function createPopupTemplate(name,time,data) {
        let AqiAvg=0;
        data.forEach(d=>{
          AqiAvg+=parseInt(d[3]);
        })
        AqiAvg=parseInt(AqiAvg / data.length)
        return new PopupTemplate({
          title: `${name}号<br/>AQI：${AqiAvg}`,
          content: createPopupContent(name,time,data),
          outFields: ["*"]
        });
      }
      // 创建弹窗内容（优化版）
      function createPopupContent(name,time,data) {
        const clone = document.querySelector('.upDateInfo').cloneNode(true);
        
        clone.id = `${name}_Infos`;
        clone.style.display = "block";
        if(ModleType=="history"){
          clone.querySelector('div').innerHTML=`${name}号--${time}--实测数据`;
          clone.querySelector('table').innerHTML=`<tr>
                                                    <td>时间</td>
                                                    <td>PM2.5</td>
                                                    <td>PM10</td>
                                                  </tr>`;
          data.forEach(d=>{
            clone.querySelector('table').innerHTML+=`<tr>
                             <td>${d[4].substr(-5).replace('-',':')}</td>
                             <td>${d[1]}</td>
                             <td>${d[2]}</td>
                           </tr>`;
          })
        }
        else{
          clone.querySelector('div').innerHTML=`${name}号--预测数据`;
          clone.querySelector('table').innerHTML=`<tr>
                                                    <td>时间</td>
                                                    <td>PM2.5</td>
                                                    <td>PM10</td>
                                                  </tr>`;
          data.forEach(d=>{
            clone.querySelector('table').innerHTML+=`<tr>
                             <td>${pridectMap[time]}</td>
                             <td>${d[1]}</td>
                             <td>${d[2]}</td>
                           </tr>`;
          })
        }
        return clone;
      }
      //模式切换监听
      //!!!!!!!!!!!!!!!!!!!!!!!!!!!历史!!!!!!!!!!!!!!!!!!!!!!!!!!
      //!!!!!!!!!!!!!!!!!!!!!!!!!!!历史!!!!!!!!!!!!!!!!!!!!!!!!!!
      //!!!!!!!!!!!!!!!!!!!!!!!!!!!历史!!!!!!!!!!!!!!!!!!!!!!!!!!
      historyBtn.addEventListener('click', (e) => {
        if(ModleType!="history"){
          if(This.activeL1){This.Leftclick1();}
          if(This.activeL2){This.Leftclick2();}
          if(This.activeL3){This.Leftclick3();}

          if(This.activeR1){This.Rightclick1();}
          if(This.activeR2){This.Rightclick2();}
          if(This.activeR3){This.Rightclick3();}
          if(This.activeR4){This.Rightclick4();}
          if(This.activeR5){This.Rightclick5();}
          rasterNow=null;
          if(allPixelDatasH!=null) allPixelDatas=allPixelDatasH;
          else allPixelDatas=null;
          resizeObserver=null;
          allPixelDatas_line={};
          allPixelDatas_area={};
          ModleType="history";
          historyBtn.classList.replace("historyBtnOff","historyBtnAct");
          pridectBtn.classList.replace("pridectBtnAct","pridectBtnOff");
          $.ajax({
              url: 'http://132.232.99.181:1111/BsHandler.aspx?index=8&key=0',
              type: 'POST',
              processData: false,
              contentType: false,
              success: function (response) {
                function sortDateArray(arr) {
                    return arr.slice().sort((a, b) => {
                        // 提取日期字符串并拆分为年、月、日
                        const aParts = a[0].split('-').map(Number);
                        const bParts = b[0].split('-').map(Number);
                
                        // 按年 -> 月 -> 日优先级比较
                        if (aParts[0] !== bParts[0]) return aParts[0] - bParts[0]; // 年不同
                        if (aParts[1] !== bParts[1]) return aParts[1] - bParts[1]; // 月不同
                        return aParts[2] - bParts[2];                             // 日不同
                    });
                }

                var json = JSON.parse(response);
                let Rdate = sortDateArray(json);
                date = [];
                if(HistorySet=="0"){
                  let xx=0;
                  for(xx;xx<Rdate.length;xx++){
                    date.push(Rdate[xx]);
                  }
                }
                else{
                  let xx;
                  if(HistorySet>Rdate.length){
                    xx=0;
                  }
                  else{
                    xx=Rdate.length-HistorySet;
                  }
                  for(xx;xx<Rdate.length;xx++){
                    date.push(Rdate[xx]);
                  }
                }
                if(rasterLayersH.length<date.length){
                  rasterLayersH=[];
                  for(let i=0;i<date.length;i++){
                    getRasterLayer(date[i][0].replace(/-/g, ''),'H').forEach(r=>{
                      rasterLayersH.push(r);
                    })
                  }
                }                  
                This.mapview.map.layers.removeAll();
                This.mapview.map.layers.addMany(rasterLayersH);
                //时间轴
                // 时间轴配置
                const startDate = new Date(date[0][0]);
                const endDate = new Date(date[date.length-1][0]); // 当前日期
                const totalDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
                // 创建时间轴节点
                const timeline = document.querySelector('.timeline');
                timeline.style.width=`calc(${date.length} *5* var(--baselen))`;
                timeline.innerHTML="";
                const baseline = document.createElement('div');
                baseline.className = 'baseline';
                const topbaseline = document.createElement('div');
                topbaseline.className = 'topbaseline';
                const timeshowbox = document.createElement('div');
                timeshowbox.className = 'timeshowbox';
                for(let i=0;i<date.length;i++){
                  const nodeDate = new Date(date[i][0]);
                  const daysFromStart = Math.ceil((nodeDate - startDate) / (1000 * 60 * 60 * 24));
                  const position = (daysFromStart / totalDays) * 100;
          
                  const node = document.createElement('div');
                  node.className = 'node';
                  node.style.left = `${position}%`;
                  node.dataset.date = date[i][0];
                  node.dataset.widthIndex = `${position}%`;
                  node.addEventListener('click', (e) => {
                    topbaseline.style.width=node.dataset.widthIndex;
                    timeshowbox.style.left=`calc(${node.dataset.widthIndex} - 10vw)`;
                    setTimeout(() => {
                      timeshowbox.innerHTML=date[i][0];
                    }, 500);
                    document.querySelectorAll('.node').forEach(n => {
                      n.classList.remove('node_active');
                    });
                    setTimeout(() => {
                      node.classList.add('node_active');
                    }, 300);
                    //根据date设置叠加地图
                    let formattedDate = date[i][0];
                    relicontrol.variable1 = i;
                    relicontrol.variable2=formattedDate;
  
                    //给点添加POP----当点位打开时执行
                    This.mapview.popup.close();
                    if(This.activeR1&&IsRun){
                      $.ajax({
                        url: `http://132.232.99.181:1111/BsHandler.aspx?index=10&key=${formattedDate}`,
                        type: 'POST',
                        processData: false,
                        contentType: false,
                        success: function (response) {
                          let json = JSON.parse(response);
                          pointsData.forEach(p=>{
                            let d=[];
                            json.forEach(j=>{
                              if(j[0]==p[0]){d.push(j);}
                            })
                            const graphic = graphicIndex.get(p[0]);
                            graphic.popupTemplate=createPopupTemplate(p[0],formattedDate,d);
                          })
                        }
                      })
                    }
  
                  });
                  timeline.appendChild(node);
                };
                timeline.insertBefore(baseline, timeline.firstChild);
                timeline.insertBefore(topbaseline, timeline.firstChild);
                timeline.insertBefore(timeshowbox, timeline.firstChild);
                listenTimeline(topbaseline);
                var nodes=document.querySelectorAll('.node');
                setTimeout(() => {
                  nodes[0].click();
                }, 1800);
              },
              error: function (response) {
                  console.log(response);
              }
          });
        }
      });
      historyBtn.click();
      //!!!!!!!!!!!!!!!!!!!!!!!!!!!预测!!!!!!!!!!!!!!!!!!!!!!!!!!
      //!!!!!!!!!!!!!!!!!!!!!!!!!!!预测!!!!!!!!!!!!!!!!!!!!!!!!!!
      //!!!!!!!!!!!!!!!!!!!!!!!!!!!预测!!!!!!!!!!!!!!!!!!!!!!!!!!
      function generateTimeSlots() {
          const now = new Date();
          const currentMinutes = now.getMinutes();
          const currentHours = now.getHours();
          
          // 计算当前时间的总分钟数
          const totalMinutes = currentHours * 60 + currentMinutes;
          // 计算下一个半小时节点的总分钟数
          const next30 = Math.ceil(totalMinutes / 30) * 30;
          
          // 计算需要增加的分钟数
          const diff = next30 - totalMinutes;
          // 创建起始时间对象
          const startTime = new Date(now.getTime() + diff * 60000);
          
          const result = {};
          for (let i = 0; i < 10; i++) {
              const time = new Date(startTime.getTime() + i * 30 * 60000);
              const hours = time.getHours().toString().padStart(2, '0');
              const minutes = time.getMinutes().toString().padStart(2, '0');
              result[(i + 1).toString()] = `${hours}:${minutes}`;
          }
          
          return result;
      }
      pridectBtn.addEventListener('click', (e) => {
        if(ModleType!="pridect"){
          if(This.activeL1){This.Leftclick1();}
          if(This.activeL2){This.Leftclick2();}
          if(This.activeL3){This.Leftclick3();}

          if(This.activeR1){This.Rightclick1();}
          if(This.activeR2){This.Rightclick2();}
          if(This.activeR3){This.Rightclick3();}
          if(This.activeR4){This.Rightclick4();}
          if(This.activeR5){This.Rightclick5();}
          pridectMap=generateTimeSlots();
          rasterNow=null;
          if(allPixelDatasP!=null) allPixelDatas=allPixelDatasP;
          else allPixelDatas=null;
          resizeObserver=null;
          allPixelDatas_line={};
          allPixelDatas_area={};
          ModleType="pridect";
          historyBtn.classList.replace("historyBtnAct","historyBtnOff");
          pridectBtn.classList.replace("pridectBtnOff","pridectBtnAct");


          //const outPolygonGeo = JSON.parse(FxRange)[0].geometry;
          ////console.log(Polygon.fromJSON(outPolygonGeo));
          //const param = {
          //  geometry: Polygon.fromJSON(outPolygonGeo),
          //  returnFirstValueOnly: false,
          //  // resolution - unit of the view's spatial reference
          //  pixelSize: {
          //    x:3,
          //    y:3,
          //    spatialReference: This.mapview.spatialReference
          //  },
          //  interpolation: "nearest",
          //  // unit of the geometry's spatial reference is used
          //  sampleDistance: 30,
          //  outFields: ["*"]
          //};
          //This.mapview.map.layers.addMany([xx]);
          //let rasters=This.mapview.map.findLayerById(`IDW_2025412_AQI`);
          //console.log(rasters);

          //  let xx =  new ImageryLayer({
          //    id:`IDW_2025412_AQI`,
          //    url: `http://132.232.99.181:1212/arcgis/rest/services/BsShow/XqPredict/ImageServer`,
          //    definitionExpression: `NAME = 'IDW_1_AQI'`,
          //  })
          //  xx.load().then(()=>{
          //    xx.getSamples(param).then((results) => {
          //      console.log(results);
          //    })
          //    .catch((error)=>{
          //      console.log(error);
          //    })
          //  })
          

          date = [['1'],['2'],['3'],['4'],['5'],['6'],['7'],['8'],['9'],['10']];
          if(rasterLayersP.length<date.length){
            rasterLayersP=[];
            for(let i=0;i<date.length;i++){
              getRasterLayer(date[i][0],'P').forEach(r=>{
                rasterLayersP.push(r);
              })
            }
          }
          This.mapview.map.layers.removeAll();
          This.mapview.map.layers.addMany(rasterLayersP);

          //let rasters=This.mapview.map.findLayerById(`IDW_202511_AQI`);
          //console.log(rasters);
          //function gg(){
          //  rasters.load().then(()=>{
          //    rasters.getSamples(param).then((results) => {
          //      console.log(results);
          //    })
          //    .catch((error)=>{
          //      console.log(error);
          //    })
          //  })
          //}
          //gg();

          //时间轴
          // 时间轴配置
          const totalDays = Math.ceil((10 - 1));
          // 创建时间轴节点
          const timeline = document.querySelector('.timeline');
          timeline.style.width=`calc(${date.length} *5* var(--baselen))`;
          timeline.innerHTML="";
          const baseline = document.createElement('div');
          baseline.className = 'baseline';
          const topbaseline = document.createElement('div');
          topbaseline.className = 'topbaseline';
          const timeshowbox = document.createElement('div');
          timeshowbox.className = 'timeshowbox';
          for(let i=0;i<date.length;i++){
            const nodeDate = parseInt(date[i][0]);
            const daysFromStart = Math.ceil((nodeDate - 1));
            const position = (daysFromStart / totalDays) * 100;
          
            const node = document.createElement('div');
            node.className = 'node';
            node.style.left = `${position}%`;
            node.dataset.date = date[i][0];
            node.dataset.widthIndex = `${position}%`;
            node.addEventListener('click', (e) => {
              topbaseline.style.width=node.dataset.widthIndex;
              timeshowbox.style.left=`calc(${node.dataset.widthIndex} - 10vw)`;
              setTimeout(() => {
                timeshowbox.innerHTML=pridectMap[date[i][0]];
              }, 500);
              document.querySelectorAll('.node').forEach(n => {
                n.classList.remove('node_active');
              });
              setTimeout(() => {
                node.classList.add('node_active');
              }, 300);
              //根据date设置叠加地图
              let formattedDate = date[i][0].toString();
              relicontrol.variable1 = i;
              relicontrol.variable2=formattedDate;
  
              //给点添加POP----当点位打开时执行
              This.mapview.popup.close();
              let key=`P,${Echart_datas_control.name}`;
              if(This.activeR1&&IsRun){
                $.ajax({
                  url: `http://132.232.99.181:1111/BsHandler.aspx?index=9&key=${key}`,
                  type: 'POST',
                  processData: false, 
                  contentType: false,
                  success: function (response) {
                    let json = JSON.parse(response);
                    pointsData.forEach(p=>{
                      let d=[];
                      json.forEach(j=>{
                        if(j[0].split('_')[1]==reliTime){d.push(j);}
                      })
                      const graphic = graphicIndex.get(p[0]);
                      graphic.popupTemplate=createPopupTemplate(p[0],formattedDate,d);
                    })
                  }
                })
              }
            });
            timeline.appendChild(node);
          };
          timeline.insertBefore(baseline, timeline.firstChild);
          timeline.insertBefore(topbaseline, timeline.firstChild);
          timeline.insertBefore(timeshowbox, timeline.firstChild);
          listenTimeline(topbaseline);
          var nodes=document.querySelectorAll('.node');
          setTimeout(() => {
            nodes[0].click();
          }, 1800);

        }
              //date = json;
              //console.log(date);
              //
              ////时间轴
              //// 时间轴配置
              //const startDate = new Date(date[0][0]);
              //const endDate = new Date(date[date.length-1][0]); // 当前日期
              //const totalDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
              //// 创建时间轴节点
              //const timeline = document.querySelector('.timeline');
              //timeline.style.width=`calc(${date.length} *5* var(--baselen))`;
              //timeline.innerHTML="";
              //const baseline = document.createElement('div');
              //baseline.className = 'baseline';
              //const topbaseline = document.createElement('div');
              //topbaseline.className = 'topbaseline';
              //const timeshowbox = document.createElement('div');
              //timeshowbox.className = 'timeshowbox';
              //for(let i=0;i<date.length;i++){
              //  const nodeDate = new Date(date[i][0]);
              //  const daysFromStart = Math.ceil((nodeDate - startDate) / (1000 * 60 * 60 * 24));
              //  const position = (daysFromStart / totalDays) * 100;
        //
              //  const node = document.createElement('div');
              //  node.className = 'node';
              //  node.style.left = `${position}%`;
              //  node.dataset.date = date[i][0];
              //  node.dataset.widthIndex = `${position}%`;
              //  node.addEventListener('click', (e) => {
              //    topbaseline.style.width=node.dataset.widthIndex;
              //    timeshowbox.style.left=`calc(${node.dataset.widthIndex} - 10vw)`;
              //    setTimeout(() => {
              //      timeshowbox.innerHTML=date[i][0];
              //    }, 500);
              //    document.querySelectorAll('.node').forEach(n => {
              //      n.classList.remove('node_active');
              //    });
              //    node.classList.add('node_active');
              //    //根据date设置叠加地图
              //    let formattedDate = date[i][0];
              //    relicontrol.variable1 = i;
              //    relicontrol.variable2=formattedDate;
              //  });
              //  timeline.appendChild(node);
              //};
              //timeline.insertBefore(baseline, timeline.firstChild);
              //timeline.insertBefore(topbaseline, timeline.firstChild);
              //timeline.insertBefore(timeshowbox, timeline.firstChild);
              //var nodes=document.querySelectorAll('.node');
              //nodes[0].click();
      });
      //时间切换监听
      let RelituControls=document.querySelector('.relituControlBox').querySelectorAll('div');
      RelituControls[0].addEventListener('click',function(){
        this.classList.add('relituControlBoxAct');
        setTimeout(() => {
          this.classList.remove('relituControlBoxAct');
        }, 200);
        if(relicontrol.variable1>0){
          document.querySelectorAll('.node')[relicontrol.variable1-1].click();
        }
      })
      //更改透明度
      let pixelSliderO = new Slider({
        container: "dur",
        min: 0,
        max: 1,
        steps: 0.01,
        values: [1],
        layout:"vertical",
        visibleElements: {
          labels: false,
          rangeLabels: false
        }
      });
      pixelSliderO.on(["thumb-drag", "thumb-change", "segment-drag"], updatepixelSliderO);
      function updatepixelSliderO() {
		    opacityAll=pixelSliderO.values[0];
		    document.querySelector('.durFont').innerHTML=opacityAll;
		    animateValue(This.mapview.map.findLayerById(`IDW_${reliTime.replace(/-/g, '')}_AQI`), opacityAll);
      }
      //阈值更改
      //document.getElementById('yuzhi').addEventListener('change',function(){
      //  yuzhi_control.yuzhi=this.value;
      //})
      pixelSlider = new Slider({
        container: "yuzhi",
        min: 0,
        max: 100,
        steps: 1,
        values: [0, 100],
        visibleElements: {
          labels: true,
          rangeLabels: true
        }
      });
      pixelSlider.on(["thumb-drag", "thumb-change", "segment-drag"], updatePixelFilter);
      function updatePixelFilter() {
        staticyuzhi=false;
        yuzhi_control.yuzhiMin = Math.floor(pixelSlider.values[0]);
        yuzhi_control.yuzhiMax = Math.floor(pixelSlider.values[1]);
      }
      let pixelSliderS = new Slider({
        container: "Syuzhi",
        min: 0,
        max: 300,
        steps: 1,
        values: [50],
        layout:"horizontal",
        visibleElements: {
          labels: true,
          rangeLabels: true
        }
      });
      pixelSliderS.on(["thumb-drag", "thumb-change", "segment-drag"], updatePixelFilterS);
      function updatePixelFilterS() {
        staticyuzhi=true;
        yuzhi_control.yuzhiMin = Math.floor(pixelSliderS.values[0]);
        yuzhi_control.yuzhiMax = 1000;
      }
      
      let pixelSliderR = new Slider({
        container: "yuzhiR",
        min: 0,
        max: 255,
        steps: 1,
        values: [255],
        layout:"horizontal",
        visibleElements: {
          labels: true,
          rangeLabels: false
        }
      });
      let pixelSliderG = new Slider({
        container: "yuzhiG",
        min: 0,
        max: 255,
        steps: 1,
        values: [0],
        layout:"horizontal",
        visibleElements: {
          labels: true,
          rangeLabels: false
        }
      });
      let pixelSliderB = new Slider({
        container: "yuzhiB",
        min: 0,
        max: 255,
        steps: 1,
        values: [0],
        layout:"horizontal",
        visibleElements: {
          labels: true,
          rangeLabels: false
        }
      });
      pixelSliderR.on(["thumb-drag", "thumb-change", "segment-drag"], updateR5R);
      pixelSliderG.on(["thumb-drag", "thumb-change", "segment-drag"], updateR5G);
      pixelSliderB.on(["thumb-drag", "thumb-change", "segment-drag"], updateR5B);
      function updateR5R(){yuzhi_control.R=Math.floor(pixelSliderR.values[0]);document.querySelector('.Echart_thres_right').style.setProperty('--rindex',Math.floor(pixelSliderR.values[0]));}
      function updateR5G(){yuzhi_control.G=Math.floor(pixelSliderG.values[0]);document.querySelector('.Echart_thres_right').style.setProperty('--gindex',Math.floor(pixelSliderG.values[0]));}
      function updateR5B(){yuzhi_control.B=Math.floor(pixelSliderB.values[0]);document.querySelector('.Echart_thres_right').style.setProperty('--bindex',Math.floor(pixelSliderB.values[0]));}
      //播放
      let timerRun;
      RelituControls[1].addEventListener('click',function(){
        const nodes=document.querySelectorAll('.node');
        if(IsRun){
          this.classList.add("relituControlBoxAct");
          this.innerHTML="||";
          IsRun=false;
          timerRun=setInterval(function () {
            if(IsRun){
              clearInterval(timerRun);
            }
            if(relicontrol.variable1==date.length-1){
              nodes[0].click();
            }
            else{
              nodes[relicontrol.variable1+1].click();
            }
          }, 600);
        }
        else{
          this.classList.remove("relituControlBoxAct");
          this.innerHTML="&nbsp;▶";
          IsRun=true;
        }
      })
      RelituControls[2].addEventListener('click',function(){
        this.classList.add('relituControlBoxAct');
        setTimeout(() => {
          this.classList.remove('relituControlBoxAct');
        }, 200);
        if(relicontrol.variable1<date.length-1){
          document.querySelectorAll('.node')[relicontrol.variable1+1].click();
        }
      })

      //点位切换监听
      let EchartDateChangeControls=document.querySelector('.Echart_datas_ControlBox').querySelectorAll('div');
      EchartDateChangeControls[0].addEventListener('click',function(){
        this.classList.add('relituControlBoxAct');
        setTimeout(() => {
          this.classList.remove('relituControlBoxAct');
        }, 200);
        if(Echart_datas_control.name!='01'){
          let x=parseInt(Echart_datas_control.name)-1;
          Echart_datas_control.name=x>9?x.toString():`0${x}`;
        }
        else{
          Echart_datas_control.name='18';
        }
        const graphic = graphicIndex.get(Echart_datas_control.name);
        This.mapview.popup.open({
          features: [graphic],
          location: [graphicIndex.get(Echart_datas_control.name).geometry.x,graphicIndex.get(Echart_datas_control.name).geometry.y]
        });
      })

      let timerRunPN;
      EchartDateChangeControls[1].addEventListener('click',function(){
        if(IsRunPN){
          this.classList.add("relituControlBoxAct");
          this.innerHTML="||";
          IsRunPN=false;
          timerRunPN=setInterval(function () {
            if(IsRunPN){
              clearInterval(timerRunPN);
            }
            if(Echart_datas_control.name!='18'){
              let x=parseInt(Echart_datas_control.name)+1;
              Echart_datas_control.name=x>9?x.toString():`0${x}`;
            }
            else{
              Echart_datas_control.name='01';
            }
          }, 600);
        }
        else{
          this.classList.remove("relituControlBoxAct");
          this.innerHTML="&nbsp;▶";
          IsRunPN=true;
        }
      })
      EchartDateChangeControls[2].addEventListener('click',function(){
        this.classList.add('relituControlBoxAct');
        setTimeout(() => {
          this.classList.remove('relituControlBoxAct');
        }, 200);
        if(Echart_datas_control.name!='18'){
          let x=parseInt(Echart_datas_control.name)+1;
          Echart_datas_control.name=x>9?x.toString():`0${x}`;
        }
        else{
          Echart_datas_control.name='01';
        }
        const graphic = graphicIndex.get(Echart_datas_control.name);
        This.mapview.popup.open({
          features: [graphic],
          location: [graphicIndex.get(Echart_datas_control.name).geometry.x,graphicIndex.get(Echart_datas_control.name).geometry.y]
        });
      })

      //用户界面
      if(userid!=""){
        user_refresh();
      }
      let userinfo = document.querySelector('.userinfo');
      let login = document.querySelector('.login');
      let closeuserinfo=document.querySelector('.closeuserinfo');
      let userinforBtn=document.querySelector('.userinforBtn');
      let login_close= document.querySelector('.login_close');
      let idinput=document.querySelector('.loginBox_inputs_id');
      let pwdinput= document.querySelector('.loginBox_inputs_pwd');
      let loginBox_submit=document.querySelector('.loginBox_submit');
      let historySet_set=document.querySelector('.historySet_set')
      let gun=document.querySelector('.gun')
      //登录
      closeuserinfo.addEventListener('click',function(){
        userinfo.style.transform=`translateX(-100%)`;
        if(ModleType=="history"){
          ModleType="predict";
          historyBtn.click();
        }
        let name=document.querySelector('.nc_content').value;
        setTimeout(() => {
          user_upUser(userid,name,HistorySet);
        }, 500);
      })
      login_close.addEventListener('click',function(){
         login.style.transform=`translateY(100%)`;
         login.style.display=`none`;
      })

      function isValidPhoneNumber(phoneNumber) {
        // 定义一个正则表达式，用于匹配中国大陆的手机号
        const phoneRegex = /^1[3-9]\d{9}$/;
        
        // 使用正则表达式测试手机号是否匹配
        return phoneRegex.test(phoneNumber);
      }
       
      loginBox_submit.addEventListener('click',function(){
        if(isValidPhoneNumber(idinput.value)){
          user_idcheck(idinput.value,pwdinput.value);
        }
        else {
          document.querySelector('.loginBox_tishi').innerHTML="请输入正确的手机号！"
        }
      })
      //信息
      userinforBtn.addEventListener('click',function(){
        if(userid!=""){
          userinfo.style.transform=`translateX(0)`;
        }
        else{
          login.style.transform=`translateY(0)`;
          login.style.display=`block`;
          idinput.value="";
          pwdinput.value="";
          document.querySelector('.loginBox_tishi').innerHTML="提示：自动注册，账号为手机号，密码为初次登录时设置的密码，验证码登录暂不可用"
        }
      })
      gun.addEventListener('click',()=>{
        closeuserinfo.click();
        userid="";
      })
      //照片
      let changebg= document.querySelector('.changebg');
      let upbg= document.querySelector('#upbg');
      let tx= document.querySelector('.tx');
      let uptx= document.querySelector('#uptx');
      changebg.addEventListener('click',()=>{
        upbg.click();
      })
      upbg.addEventListener('change', function (event) {
        // 获取选中的文件列表
        const file = event.target.files[0];
        if (file) {
          user_upImg(userid,'bg',file);
        }
      });
      tx.addEventListener('click',()=>{
        uptx.click();
      })
      uptx.addEventListener('change', function (event) {
        // 获取选中的文件列表
        const file = event.target.files[0];
        if (file) {
          user_upImg(userid,'tx',file);
        }
      });
      //改变历史
      historySet_set.addEventListener('change',function(){
        HistorySet=this.value;
      })
    },
    methods: {
        goLogin() {
          this.$router.push('/Login')
        },
      loadArcgisMap() {
        let x=restoreLayer(FxRange);
        window.outerGraphic=x;
        graphicList["西科大边界"]=[];
        graphicList["西科大边界"].push(0);
        x.forEach(l=>{
          l.symbol.color=null;
          graphicList["西科大边界"].push(l);
          baseExtent=l;
        })
        graphcAddIndex++;

        webmap = new WebMap({
          portalItem: {
            id: "46b9d513cf7344fbb36b6ac2cef04cc1"
          },
        });
        var chinaExtent = new Extent({
          xmin: 73.66,
          ymin: 18.15,
          xmax: 135.09,
          ymax: 53.56,
          spatialReference: { wkid: 4326 } // WGS 84
        });
        this.mapview = new MapView({
          container: "mapView",
          map: webmap,
          rotation:0,
          center: [104.69234, 31.53811],
          zoom: 14,
          popup:{
            dockEnabled:true,
            dockOptions: {
              position: "bottom-centered",
              breakpoint:{width: 120, height: 180},
            },
          }
        });
        this.mapview.constraints = {
          minZoom: 8,
          extent: chinaExtent
        };
        pointsLayer = new GraphicsLayer();

        //弹窗
        function showPopup(graphic, location) {
          // 配置弹窗内容
          const content = `
            <div>
              <h4>${graphic.attributes.name || "未命名"}</h4>
              <p>坐标: ${location.x.toFixed(3)}, ${location.y.toFixed(3)}</p>
            </div>
          `;
        
          // 打开弹窗
          this.mapview.popup.open({
            location: location,
            content: content,
            updateLocationEnabled: true // 允许弹窗随地图移动更新位置
          });
        }

        // 点符号配置
        const markerSymbol = new SimpleMarkerSymbol({
          color: [226, 119, 40, 0.8],
          outline: {
            color: [255, 255, 255],
            width: 1
          },
          size: "12px"
        });
  
        // 创建图形要素
        function createPointGraphic([name, lng, lat]) {
          const point = new Graphic({
            geometry: { type: "point", longitude: lng, latitude: lat },
            symbol: markerSymbol,
            attributes: { name },
          });
          return point;
        }
  
        // 初始化地图视图后绑定事件
        this.mapview.when(() => {
          // 绑定弹窗动作事件
          this.mapview.popup.on("trigger-action", (event) => {
            if (event.action.id === "saveData") {
              handleSaveAction();
            }
          });

          //点击事件
          this.mapview.on("click", (event) => {
            //setTimeout(() => {
            //  if (this.mapview.popup.visible) {
            //    Echart_datas_control.name=this.mapview.popup.title.slice(0, 2);
            //  }
            //}, 800);
            if(This.activeR1){
              this.mapview.hitTest(event).then((hitTestResults) => {
                // 检查是否命中任何图形
                if (hitTestResults.results.length > 0) {
                  // 遍历命中的结果
                  for(var i=0;i<hitTestResults.results.length;i++){
                    // 确认命中的图形属于 view.graphics（排除其他图层）
                    if (hitTestResults.results[i].graphic.attributes && hitTestResults.results[i].graphic.attributes.hasOwnProperty('name')) {
                      Echart_datas_control.name=hitTestResults.results[i].graphic.attributes.name;
                      break;
                    }
                  };
                }
              });
            }
            else if(this.activeR3||this.activeR4){
            // 执行命中测试（异步操作）
              this.mapview.hitTest(event).then((hitTestResults) => {
                // 检查是否命中任何图形
                if (hitTestResults.results.length > 0) {
                  // 遍历命中的结果
                  for(var i=0;i<hitTestResults.results.length;i++){
                    // 确认命中的图形属于 view.graphics（排除其他图层）
                    if (hitTestResults.results[i].graphic.attributes && hitTestResults.results[i].graphic.attributes.hasOwnProperty('name')) {
                      // 执行自定义方法（例如弹窗显示属性）
                      if(hitTestResults.results[i].graphic.attributes.name.includes("距离")){
                        let minis=document.querySelectorAll('.miniBox');
                        minis.forEach(m=>{
                          if(m.querySelectorAll('div')[1].innerHTML==hitTestResults.results[i].graphic.attributes.name){
                            m.querySelectorAll('div')[1].click();
                          }
                        })
                        break;
                      }
                      if(hitTestResults.results[i].graphic.attributes.name.includes("面积")){
                        let minis=document.querySelectorAll('.miniBox');
                        minis.forEach(m=>{
                          if(m.querySelectorAll('div')[1].innerHTML==hitTestResults.results[i].graphic.attributes.name){
                            m.querySelectorAll('div')[1].click();
                          }
                        })
                        break;
                      } 
                    
                    }
                  };
                }
              });
            }
          });
        });
        function setDataStore(name) {
          pointDataStore[name] = {
            time: getLocalTimeString(), // 初始化为当前时间
            co2: ''
          };
          const graphic = graphicIndex.get(name);
          graphic.popupTemplate=createPopupTemplate(name);
          //contentNode.querySelector('input[type="time"]').value=getLocalTimeString();
        }
        // 保存动作处理函数
        function handleSaveAction() {
          const feature = This.mapview.popup.selectedFeature;
          if (!feature) return;
        
          const name = feature.attributes.name;
          const contentId = `${name}_Infos`;
          const contentNode = document.getElementById(contentId);
        
          if (!contentNode) return;
          const inputs = {
            time: contentNode.querySelector('input[type="time"]'),
            co2: contentNode.querySelector('input[type="number"]')
          };
  
          // 更新数据存储
          pointDataStore[name] = {
            time: inputs.time.value,
            co2: inputs.co2.value
          };
          // 更新样式
          const jianceNode = jianceDianNodes[name];
          if (jianceNode) {
            jianceNode.classList.add('data-saved');
          }
  
          // 模拟保存到服务器
  /*         fetch('/api/save', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name, ...pointDataStore[name] })
          }).catch(console.error); */
        }
  
        // 初始化检测点交互（优化性能）
        function initJianceDianInteraction() {
          const container = document.querySelector('.jiancedianBox');
    
          // 使用事件委托
          container.addEventListener('click', (e) => {
            const target = e.target.closest('.jiancedianwei');
            if (!target) return;
  
            const name = target.textContent;
            const point = pointsData.find(p => p[0] === name);
            
            This.mapview.popup.close();
            if (point) {
              setDataStore(name);
              const graphic = graphicIndex.get(name);
              This.mapview.popup.open({
                features: [graphic],
                location: [graphicIndex.get(name).geometry.x,graphicIndex.get(name).geometry.y]
              });
              This.mapview.goTo({
                center: [point[1], point[2]],
                zoom: 16
              }, { duration: 500 });
            }
          });
  
          // 缓存DOM节点
          document.querySelectorAll('.jiancedianwei').forEach(node => {
            jianceDianNodes[node.textContent] = node;
          });
        }
  
        // 初始化点图层
        function initializePoints() {
          pointsLayer.removeAll();
          pointsData.forEach(point => {
            graphicIndex.set(point[0], createPointGraphic(point));
            pointsLayer.add(graphicIndex.get(point[0]));
          });
  
          initJianceDianInteraction();
        }
  
        initializePoints();
  
        this.mapview.ui.components = []; // 清空所有 ESRI 自带的组件
  
        this.regionMap =  JSON.stringify({
          center: this.mapview.center, // 中心点
          zoom: this.mapview.zoom,     // 缩放级别
          rotation: this.mapview.rotation, // 旋转角度
          extent: this.mapview.extent  // 当前范围
        })
        draw = new Draw({
          view: this.mapview
        });

        this.ReRenderMapView();
      },

      // 随机颜色
      getRandomBrightColor() {
        const r = Math.floor(Math.random() * 188) + 68; // 128-255
        const g = Math.floor(Math.random() * 128) + 128; // 128-255
        const b = Math.floor(Math.random() * 128) + 128; // 128-255
        return [r, g, b];
      },
      //点击元素动画
      activeSomeEle(ele){
        ele.classList.add('activeSomething');
        setTimeout(() => {
          ele.classList.remove('activeSomething');
        }, 100);
      },
      //渲染MapView
      ReRenderMapView(){
        this.mapview.graphics.removeAll();
        for(var key in graphicList){
          if(graphicList[key][0]==0){
            for(var i=1;i<graphicList[key].length;i++){
              this.mapview.graphics.add(graphicList[key][i]);
            }
          }
        }
      },
      setColorOp(color,op){
        return [...color, op];
      },
      //更新图层索引
      NewLayer(){
        graphiIndex++;
        currentColor=this.getRandomBrightColor();
      },
      // 左侧按钮事件
      setActiveButton(buttonId) {
        this.activeButton = this.activeButton === buttonId ? null : buttonId;
      },
  
      //长度测量
      createPolyline(event) {
        var vertices = event.vertices;
        var symbol={
          type:"simple-marker",
          color:[255,255,255],
          size:6,
          outline: {
            color: [ 255, 0, 0 ],
            width: 1.5  // points
          }
        };
        this.mapview.graphics.removeAll();
        var graphics=new Graphic({
          geometry:new Polyline({
              paths: vertices,
              spatialReference: this.mapview.spatialReference
          }),
          attributes:{
            name:`${graphiIndex}_距离测量`,
          },
          symbol: {
              type: "simple-line", // autocasts as new SimpleFillSymbol
              color: currentColor,
              width: 2,
              cap: "round",
              join: "round"
          }
        });
        graphicList[graphiIndex+'_距离测量']=[];
        currentKey=graphiIndex+'_距离测量';
        graphicList[graphiIndex+'_距离测量'].push(0);
        graphicList[graphiIndex+'_距离测量'].push(graphics);
        var firsttextSymbol = {
            type: "text",
            color: "white",
            haloColor: "black",
            haloSize: "10px",
            text: "起点",
            xoffset: '10px',
            yoffset: '10px',
            font: {
                size: 12,
                family: "sans-serif",
                weight: "bold"
            }
        };
   
   
        var firstpoint=new Point({
            spatialReference: this.mapview.spatialReference,
            x:vertices[0][0],
            y:vertices[0][1]
        });
        var firstTextGraphics=new Graphic({
            geometry:firstpoint,
            symbol: firsttextSymbol
        });
        var firstGraphics=new Graphic({
            geometry:firstpoint,
            symbol: symbol
        });
        graphicList[graphiIndex+'_距离测量'].push(firstTextGraphics,firstGraphics);
        var path=[];
        path.push([vertices[0][0],vertices[0][1]]);
        for (let i = 1; i <vertices.length ; i++) {
            path.push([vertices[i][0],vertices[i][1]]);
  
            var line = new Polyline({
                hasZ: false,
                hasM: true,
                paths: path,
                spatialReference: this.mapview.spatialReference
            });
   
            var dislen;
            var unit;
            if(this.mapview.scale>5000) {
                 dislen = geodesicLength(line, 'kilometers');
                 unit="千米";
            }else {
   
                 dislen = geodesicLength(line, 'meters');
                 unit="米";
            }
  
            var point=new Point({
              spatialReference: this.mapview.spatialReference,
              x:vertices[i][0],
              y:vertices[i][1]
            });
            var textSymbol = {
                type: "text",
                color: "white",
                haloColor: "black",
                haloSize: "5px",
                text: Math.abs(Math.round(dislen*100)/100)+unit,
                xoffset: '20px',
                yoffset: '20px',
                font: {
                    size: 12,
                    family: "sans-serif",
                    weight: "bold"
                }
            };
            var textGraphics=new Graphic({
                geometry:point,
                symbol: textSymbol
            });
   
            var Graphics=new Graphic({
                geometry:point,
                symbol: symbol
            });
            graphicList[graphiIndex+'_距离测量'].push(textGraphics,Graphics);
        }
        this.ReRenderMapView();
      },
      ActiveDistanceTool(){
        var tools=document.querySelector('.DistanceTool').querySelectorAll('div');
        tools[0].addEventListener('click',function(){
          try{if(action.canUndo()){This.activeSomeEle(tools[0]);action.undo();}}
          catch{ This.ReRenderMapView();}
        })
        tools[1].addEventListener('click',function(){
          This.activeSomeEle(tools[1]);
          try{
            if (action && action.vertices && action.vertices.length > 0) {
              action.complete();
              This.NewLayer();
            } else {
              try{action.destroy();}
              catch{1==1;}
            }
          }
          catch{1==1;}
          This.addDistance=false;
          tools[2].classList.remove('activeSomething');
          currentKey=null;
          This.ReLoadLayerBox();
        })
        tools[2].addEventListener('click',function(){
          if(!This.addDistance){
            tools[2].classList.add('activeSomething');
            This.DrawDistanceMeasure();
            This.addDistance=true;
          }
          else{
            try{tools[2].classList.remove('activeSomething');}
            catch{1==1;}
            try{delete graphicList[currentKey];This.ReRenderMapView();action.destroy();}
            catch{1==1;}
            This.addDistance=false;
          }
        })
      },
      DrawDistanceMeasure(){
        action = draw.create("polyline",{mode: "click"});
        if(MP=="Mobile"){
          action.on(
              [
                "vertex-add",
                "vertex-remove",
                //"cursor-update",
                "redo",
                "undo",
                "draw-complete"
              ],
              this.createPolyline
          );
        }
        else{
          action.on(
              [
                "vertex-add",
                "vertex-remove",
                "cursor-update",
                "redo",
                "undo",
                "draw-complete"
              ],
              this.createPolyline
          );
        }
      },
      showSomeEle(ele){
        ele.style.filter= `blur(0)`;
        ele.style.scale= `1`;
        ele.style.opacity= `1`;
        ele.style.zIndex= 4;
      },
      hiddenSomeEle(ele){
        ele.style.filter= `blur(4vw)`;
        ele.style.scale= `2`;
        ele.style.opacity= `0`;
        ele.style.zIndex= -1;
      },
      Leftclick1() {
        this.setActiveButton('button1');
        var ele=document.querySelector('.DistanceTool');
        if(!this.activeL1){
          this.showOnly('L1');
          This.addDistance=false;
          ele.querySelectorAll('div')[2].click();
          this.activeL1=true;
        }
        else{
          this.hiddenSomeEle(ele);
          if(This.addDistance){
            ele.querySelectorAll('div')[2].click();
          }
          this.activeL1=false;
        }
      },
  
      //面积测量
      createPolygon(event) {
        var vertices = event.vertices;
        // if(vertices.length==1){vertices=vertices.push(vertices[0]);}
        // var rings=vertices.push(vertices[0]);
        var symbol={
          type:"simple-marker",
          color:[255,255,255],
          size:6,
          outline: {
            color: [ 255, 0, 0 ],
            width: 1.5  // points
          }
        };
        var polygon = new Polygon({
            type:'polygon',
            rings: vertices,
            spatialReference: this.mapview.spatialReference
        });
        var fillSymbol = new SimpleFillSymbol({
            color: this.setColorOp(currentColor,0.3),
            outline: {
                color: [255,116,3],
                width: 2
            }
        });
        var graphics=new Graphic({
          attributes:{
            name:`${graphiIndex}_面积测量`,
          },
          geometry: polygon,
          symbol: fillSymbol
        });
        graphicList[graphiIndex+"_面积测量"]=[];
        currentKey=graphiIndex+"_面积测量";
        graphicList[graphiIndex+'_面积测量'].push(0);
        graphicList[graphiIndex+"_面积测量"].push(graphics);
  
        for (let i = 0; i <vertices.length; i++) {
            var point=new Point({
              spatialReference: this.mapview.spatialReference,
              x:vertices[i][0],
              y:vertices[i][1]
            });
   
            var pointGraphics=new Graphic({
                geometry: point,
                symbol: symbol
            });
            graphicList[graphiIndex+"_面积测量"].push(pointGraphics);
        }
  
        var area=0;
        var unit;
        if(this.mapview.scale>5000) {
            area = geodesicArea(graphics.geometry,'square-kilometers');
            unit="平方千米";
        }else {
   
            area = geodesicArea(graphics.geometry,'square-meters');
            unit="平方米";
        }
        var center = [polygon.centroid.latitude,polygon.centroid.longitude];
        var pointcenter=new Point({
            sptialReference: this.mapview.spatialReference,
            latitude:center[0],
            longitude:center[1]
        });
        var textSymbol = {
            type: "text",
            color: "white",
            haloColor: "black",
            haloSize: "5px",
            text:Math.abs(Math.round(area*100)/100)+unit,
            font: {
                size: 12,
                family: "sans-serif",
                weight: "bold"
            }
        };
        var textGraphics=new Graphic({
            geometry:pointcenter,
            symbol: textSymbol
        });
        graphicList[graphiIndex+"_面积测量"].push(textGraphics);
        this.ReRenderMapView();
      },
      ActiveAreaTool(){
        var tools=document.querySelector('.AreaTool').querySelectorAll('div');
        tools[0].addEventListener('click',function(){
          try{if(action.canUndo()){This.activeSomeEle(tools[0]);action.undo();}}
          catch{ This.ReRenderMapView();}
        })
        tools[1].addEventListener('click',function(){
          This.activeSomeEle(tools[1]);
          try{
            if (action && action.vertices && action.vertices.length > 0) {
              action.complete();
              This.NewLayer();
            } else {
              try{action.destroy();}
              catch{1==1;}
            }
          }
          catch{1==1;}
          This.addArea=false;
          tools[2].classList.remove('activeSomething');

          /* var storageData = [];
              graphicList[currentKey].forEach(g => {
                try{
                  storageData.push(graphicToStorage(g));
                }
                catch{1==1}
              });
              const result = ajaxRequest({
                data: {id: id,name:'layer',type:0,content:JSON.stringify(storageData)},
                key: 'saveLayer',
              });
          this.responseData = result.message; */

          currentKey=null;
          This.ReLoadLayerBox();
        })
        tools[2].addEventListener('click',function(){
          if(!This.addArea){
            tools[2].classList.add('activeSomething');
            This.DrawAreaMeasure();
            This.addArea=true;
          }
          else{
            try{tools[2].classList.remove('activeSomething');}
            catch{1==1;}
            try{delete graphicList[currentKey];This.ReRenderMapView();action.destroy();}
            catch{1==1;}
            This.addArea=false;
          }
        })
      },
      DrawAreaMeasure(){
        action = draw.create("polygon", {mode: "click"});
        this.mapview.focus();
        if(MP=="Mobile"){
            action.on(
              [
                  "vertex-add",
                  "vertex-remove",
                  //"cursor-update",
                  "redo",
                  "undo",
                  "draw-complete"
              ],
              this.createPolygon
          );
        }
        else{
          action.on(
              [
                  "vertex-add",
                  "vertex-remove",
                  "cursor-update",
                  "redo",
                  "undo",
                  "draw-complete"
              ],
              this.createPolygon
          );
        }
      },
      Leftclick2() {
        this.setActiveButton('button2');
        var ele=document.querySelector('.AreaTool');
        if(!this.activeL2){
          this.showOnly('L2');
          This.addArea=false;
          ele.querySelectorAll('div')[2].click();
          this.activeL2=true;
        }
        else{
          this.hiddenSomeEle(ele);
          if(This.addArea){
            ele.querySelectorAll('div')[2].click();
          }
          this.activeL2=false;
        }
      },
  
      //背景颜色控制
      Leftclick3() {
        const opacityControl=document.querySelector('.opacityControl');
        if(!this.activeL3){
          opacityControl.style.transform = "translateX(0vw)";
          opacityControl.style.opacity = 1;
          opacityControl.style.scale = 1;
          this.activeL3=true;
        }
        else{
          opacityControl.style.transform = "translateX(-30vw)";
          opacityControl.style.scale = 0.3;
          opacityControl.style.opacity = 0;
          this.activeL3=false;
        }
      },
  
      //地图重置
      GoToRegionMap(){
        const savedState = JSON.parse(this.regionMap);
        // 恢复地图状态
        this.mapview.goTo({
          center: [104.69234, 31.53811], // 恢复中心点
          zoom: savedState.zoom,     // 恢复缩放级别
          rotation: 0 // 恢复旋转角度
        });
      },
      Leftclick4() {
        this.activeL4=true;
        setTimeout(() => {
          this.activeL4=false;
        }, 100);
        this.GoToRegionMap();
      },
  
      //底图变换
      changeBaseMap1(){
        this.activeBaseMap = 'hybrid';
        this.mapview.map.basemap ='hybrid';
      },
      changeBaseMap2(){
        this.activeBaseMap = 'topo';
        this.mapview.map.basemap ='topo-vector';
      },
      changeBaseMap3(){
        this.activeBaseMap = 'streets';
        this.mapview.map.basemap ='streets-vector';
      },
      changeBaseMap4(){
        this.activeBaseMap = 'streets-night-vector';
        this.mapview.map.basemap ='streets-night-vector';
      },
  
      //右侧按钮事件
      //点统计
      Rightclick1() {
        if(!this.activeR1){
          this.EchartShowOnly('.Echart_datas');
          document.querySelector('.mapBLBtn').style.bottom=`calc(2vw + 150px)`;
          document.querySelector('.layersBox').style.bottom=`calc(2vw + 150px)`;
          webmap.add(pointsLayer);
          if(this.activeL1){this.Leftclick1();}
          if(this.activeL2){this.Leftclick2();}
          this.activeR1=true;
          document.querySelectorAll('.node')[relicontrol.variable1].click();
          setTimeout(() => {
            this.mapview.goTo({
              center: [104.69234, 31.53511], // 恢复中心点
              zoom: 14,     // 恢复缩放级别
              rotation: 0 // 恢复旋转角度
            });
          }, 250);
        }
        else{
          document.querySelector('.mapBLBtn').style.bottom=`2vw`;
          document.querySelector('.layersBox').style.bottom=`2vw`;
          document.querySelector('.Echart_datas').style.height="0vh";
          document.querySelector('.Echart_datas').style.overflow="hidden";
          if(!IsRunPN){
            document.querySelector('.Echart_datas_ControlBox').querySelectorAll('div')[1].click();
          }
          this.activeR1=false;
          webmap.remove(pointsLayer);
          This.mapview.popup.close();
          this.GoToRegionMap();
        }
      },
      //时间轴
      Rightclick2() {
        this.setActiveButton('button7');
        if(!this.activeR2){
          this.showOnly('R2');
          this.activeR2=true;
        }
        else{
          document.getElementById('mapView').style.height=`calc(100vh - 110px)`;
          document.querySelector('.relituBox').style.height="0vh";
          if(!IsRun){
            document.querySelector('.relituControlBox').querySelectorAll('div')[1].click();
          }
          this.activeR2=false;
        }
      },
      EchartHiddenAll(){
        if(this.activeR1){this.Rightclick1();}
        if(this.activeR3){this.Rightclick3();}
        if(this.activeR4){this.Rightclick4();}
        if(this.activeR5){this.Rightclick5();}
      },
      EchartShowOnly(name){
        this.EchartHiddenAll();
        document.querySelector(name).style.height="150px";
        setTimeout(() => {
          document.querySelector(name).style.overflow="visible";
        }, 500);
      },
      //线统计
      Rightclick3() {
        if(!this.activeR3){
          this.EchartShowOnly('.Echart_lines');
          document.querySelector('.mapBLBtn').style.bottom=`calc(2vw + 150px)`;
          document.querySelector('.layersBox').style.bottom=`calc(2vw + 150px)`;
          if(this.activeL1){this.Leftclick1();}
          if(this.activeL2){this.Leftclick2();}
          if(!this.activeB1){this.layersHandle();}
          this.activeR3=true;
          let minis=document.querySelectorAll('.miniBox');
          minis.forEach(m=>{
            if(m.querySelectorAll('div')[1].innerHTML==Echart_linearea_control.linename){
              m.querySelectorAll('div')[1].click();
            }
          })
          setTimeout(() => {
            this.mapview.goTo({
              center: [104.69234, 31.53511], // 恢复中心点
              zoom: 14,     // 恢复缩放级别
              rotation: 0 // 恢复旋转角度
            });
          }, 250);
        }
        else{
          document.querySelector('.mapBLBtn').style.bottom=`2vw`;
          document.querySelector('.layersBox').style.bottom=`2vw`;
          document.querySelector('.Echart_lines').style.height="0vh";
          document.querySelector('.Echart_lines').style.overflow="hidden";
          let minis=document.querySelectorAll('.miniBox');
          minis.forEach(m=>{
            try{
              m.querySelectorAll('div')[1].classList.remove('minidivactive');
            }
            catch{}
          })
          if(this.activeB1){this.layersHandle();}
          this.activeR3=false;
          this.GoToRegionMap();
        }
      },
      //面统计
      Rightclick4() {
        if(!this.activeR4){
          this.EchartShowOnly('.Echart_areas');          
          document.querySelector('.mapBLBtn').style.bottom=`calc(2vw + 150px)`;
          document.querySelector('.layersBox').style.bottom=`calc(2vw + 150px)`;
          if(this.activeL1){this.Leftclick1();}
          if(this.activeL2){this.Leftclick2();}
          if(!this.activeB1){this.layersHandle();}
          this.activeR4=true;
          let minis=document.querySelectorAll('.miniBox');
          minis.forEach(m=>{
            if(m.querySelectorAll('div')[1].innerHTML==Echart_linearea_control.areaname){
              m.querySelectorAll('div')[1].click();
            }
          })
          setTimeout(() => {
            this.mapview.goTo({
              center: [104.69234, 31.53511], // 恢复中心点
              zoom: 14,     // 恢复缩放级别
              rotation: 0 // 恢复旋转角度
            });
          }, 250);
        }
        else{
          document.querySelector('.mapBLBtn').style.bottom=`2vw`;
          document.querySelector('.layersBox').style.bottom=`2vw`;
          document.querySelector('.Echart_areas').style.height="0vh";
          document.querySelector('.Echart_areas').style.overflow="hidden";
          let minis=document.querySelectorAll('.miniBox');
          minis.forEach(m=>{
            try{
              m.querySelectorAll('div')[1].classList.remove('minidivactive');
            }
            catch{}
          })
          if(this.activeB1){this.layersHandle();}
          this.activeR4=false;
          this.GoToRegionMap();
        }
      },
      //阈值统计
      Rightclick5() {
        if(!this.activeR5){
          this.EchartShowOnly('.Echart_thres');
          document.querySelector('.mapBLBtn').style.bottom=`calc(2vw + 150px)`;
          document.querySelector('.layersBox').style.bottom=`calc(2vw + 150px)`;
          if(this.activeL1){this.Leftclick1();}
          if(this.activeL2){this.Leftclick2();}
          this.activeR5=true;
          setR5(this.activeR5);
          setTimeout(() => {
            this.mapview.goTo({
              center: [104.69234, 31.53511], // 恢复中心点
              zoom: 14,     // 恢复缩放级别
              rotation: 0 // 恢复旋转角度
            });
          }, 250);
        }
        else{
          if(R5Raster!=null){R5Raster.renderer=null;R5Raster.rendereringRules=rendereringRules;}
          document.querySelector('.mapBLBtn').style.bottom=`2vw`;
          document.querySelector('.layersBox').style.bottom=`2vw`;
          document.querySelector('.Echart_thres').style.height="0vh";
          document.querySelector('.Echart_thres').style.overflow="hidden";
          this.activeR5=false;
          date.forEach(d=>{
            This.mapview.map.findLayerById(`IDW_${d[0].replace(/-/g, '')}_AQI`).renderingRule.functionName="AQI";
            This.mapview.map.findLayerById(`IDW_${d[0].replace(/-/g, '')}_AQI`).pixelFilter=null;
            //This.mapview.map.findLayerById(`IDW_${d[0].replace(/-/g, '')}_AQI`).renderingRule=rendereringRules;
          })
          this.GoToRegionMap();
        }
      },
      Resettoplight(){
        let minis=document.querySelectorAll('.miniBox');
        if(This.activeR3){
          minis.forEach(m=>{
            if(m.querySelectorAll('div')[1].innerHTML==Echart_linearea_control.linename){
              m.querySelectorAll('div')[1].click();
            }
          })
        }
        if(This.activeR4){
          minis.forEach(m=>{
            if(m.querySelectorAll('div')[1].innerHTML==Echart_linearea_control.areaname){
              m.querySelectorAll('div')[1].click();
            }
          })
        }
      },
      //图层管理
      ReLoadLayerBox(){
        var layerbox=document.querySelector('.layersBox');
        var miniBox=document.querySelector('.miniBox');
        layerbox.innerHTML="";
        var setIndex=false;
        for(var g in graphicList){
          if(g){setIndex=true;break;}
        }
        if(!setIndex){
          layerbox.innerHTML="地图无图层";
        }
        else{
          for(var key in graphicList){
            let keyNow=key;
            let newLayer=miniBox.cloneNode(true);
            newLayer.style.display="flex";
            layerbox.appendChild(newLayer);
            let divs=newLayer.querySelectorAll('div');
            divs[0].id=`${keyNow}_mini`;
            if(keyNow.includes("距离")){
              divs[0].style.backgroundImage="url('http://132.232.99.181:1111/img/L1_ico.png')"
            }
            else if(keyNow.includes("面积")){
              divs[0].style.backgroundImage="url('http://132.232.99.181:1111/img/L2_ico.png')"
            }
            else if(keyNow=="西科大边界"){
              divs[0].style.backgroundImage="url('http://132.232.99.181:1111/img/xkd_ico.png')"
            }
            divs[1].innerHTML=keyNow;
            if(graphicList[key][0]==0){
              divs[2].classList.add('miniDiv1');
            }
            else{
              divs[2].classList.add('miniDiv1_active');
            }
            divs[1].addEventListener('click',function(){
              if(This.activeR3||This.activeR4){
                if(divs[1].innerHTML!="西科大边界"){
                  let minis=document.querySelectorAll('.miniBox');
                  
                  if(divs[1].innerHTML.includes("距离")){
                    if(!This.activeR3){
                      This.Rightclick3();
                    }
                    else{
                      if(Echart_linearea_control.linename!=divs[1].innerHTML){
                        Echart_linearea_control.linename=divs[1].innerHTML;
                      }
                    }
                    minis.forEach(m=>{
                      if(m.querySelectorAll('div')[1].innerHTML!=Echart_linearea_control.linename){
                        try{
                          m.querySelectorAll('div')[1].classList.remove('minidivactive');
                        }
                        catch{}
                      }
                      else{
                        m.querySelectorAll('div')[1].classList.add('minidivactive');
                      }
                    })
                  }
                  else if(divs[1].innerHTML.includes("面积")){
                    if(!This.activeR4){
                      This.Rightclick4();
                    } 
                    else{
                      if(Echart_linearea_control.areaname!=divs[1].innerHTML){
                        Echart_linearea_control.areaname=divs[1].innerHTML;
                      }
                    }
                    minis.forEach(m=>{
                      if(m.querySelectorAll('div')[1].innerHTML==Echart_linearea_control.areaname){
                        m.querySelectorAll('div')[1].classList.add('minidivactive');
                      }
                      else{
                        try{
                          m.querySelectorAll('div')[1].classList.remove('minidivactive');
                        }
                        catch{}
                      }
                    })
                  }
                }
              }
            })
            This.Resettoplight();
            divs[2].addEventListener('click',function(){
              if(graphicList[keyNow][0]==0){
                graphicList[keyNow][0]=1;This.ReRenderMapView();
                divs[2].classList.replace('miniDiv1','miniDiv1_active');
              }
              else{
                graphicList[keyNow][0]=0;This.ReRenderMapView();
                divs[2].classList.replace('miniDiv1_active','miniDiv1');
              }
            })
            divs[3].classList.add('miniDiv2');
            divs[3].addEventListener('click',function(){
              This.activeSomeEle(divs[3]);
              let fullExtent = null;
              graphicList[keyNow].forEach(graphic => {
                if (graphic.geometry) {
                  fullExtent = fullExtent ? 
                    union(fullExtent, graphic.geometry.extent) : 
                    graphic.geometry.extent.clone();
                }
              });
              This.mapview.goTo({
                target:fullExtent,
              })
            })
            divs[4].classList.add('miniDiv3');
            divs[4].addEventListener('click',function(){
              This.activeSomeEle(divs[4]);
              if(userid==""){
                alert('请先登录');
              }
              else{
                if(keyNow!="西科大边界"){
                  let storageData = [];
                  graphicList[keyNow].forEach(g => {
                    try{
                      storageData.push(graphicToStorage(g));
                    }
                    catch{1==1}
                  });
                  let type="";
                  if(keyNow.includes("距离")){type="距离";}
                  else if(keyNow.includes("面积")){type="面积";}
                  let name = prompt("保存名称：",keyNow);
                  console.log(name);
                  if(name!=null){
                    user_upGeo(userid,JSON.stringify(storageData),name,type)
                  }
                }
                else{
                  alert('此图层不需保存');
                }
              }
            })
            divs[5].classList.add('miniDiv4');
            divs[5].addEventListener('click',function(){
              This.activeSomeEle(divs[5]);
              delete graphicList[keyNow];
              This.ReRenderMapView();
              This.ReLoadLayerBox();
              Echart_linearea_control.areaname=Echart_linearea_control.areaname;
              Echart_linearea_control.linename=Echart_linearea_control.linename;
            })
          }
        }
      },
      layersHandle(){
        var layerbox=document.querySelector('.layersBox');
        var btn=document.getElementById('mapView').querySelector('.mapBLBtn');
        if(!this.activeB1){
          layerbox.style.transform=` translateX(0vw) translateY(0vw)`;
          layerbox.style.scale=1;
          layerbox.style.opacity=1;
          this.ReLoadLayerBox();
          this.activeB1=true;
          btn.classList.add('activeSomething');
        }
        else{
          layerbox.style.transform=` translateX(-450vw) translateY(100vw)`;
          layerbox.style.scale=0.1;
          layerbox.style.opacity=0;
          this.activeB1=false;
          btn.classList.remove('activeSomething');
        }
      },
      //动画控制
      hiddenAll(){
        //L1
        this.hiddenSomeEle(document.querySelector('.DistanceTool'));
        if(This.addDistance){
          document.querySelector('.DistanceTool').querySelectorAll('div')[2].click();
        }
        this.activeL1=false;
  
        //L2
        this.hiddenSomeEle(document.querySelector('.AreaTool'));
        if(This.addArea){
          document.querySelector('.AreaTool').querySelectorAll('div')[2].click();
        }
        this.activeL2=false;
        
        //R1
        //document.querySelector('.mapBLBtn').style.bottom=`2vw`;
        //document.querySelector('.Echart_datas').style.height="0vh";
        //this.activeR1=false;
        //try{webmap.remove(pointsLayer);}
        //catch{1==1;}
        //This.mapview.popup.close();

        //R2
        document.getElementById('mapView').style.height=`calc(100vh - 110px)`;
        document.querySelector('.relituBox').style.height="0vh";
        this.activeR2=false;
        if(!IsRun){
          document.querySelector('.relituControlBox').querySelectorAll('div')[1].click();
        }
        //setTimeout(() => {
        //  this.GoToRegionMap();
        //}, 480);
      },
      showOnly(key){
        this.hiddenAll();
        switch(key){
          case 'L1':
            this.showSomeEle(document.querySelector('.DistanceTool'));
            this.EchartHiddenAll();
            break;
          case 'L2':
            this.showSomeEle(document.querySelector('.AreaTool'));
            this.EchartHiddenAll();
            break;
          case 'R1':
            document.querySelector('.mapBLBtn').style.bottom=`calc(2vw + 150px)`;
            document.querySelector('.Echart_datas').style.height="150px";
            webmap.add(pointsLayer);
            break;
          case 'R2':
            document.getElementById('mapView').style.height=`calc(100vh - 180px)`;
            document.querySelector('.relituBox').style.height="70px";
            break;
          case 'R3':
            break;
          case 'R4':
            break;
          case 'R5':
            break;
        }
      },
    }
  }
  </script>
  
  <style>
  #app {
    --baselen: 1vh;
    font-family: "华文楷体";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  .login{
    width: 100%;
    height: 100%;
    z-index: 20;
    background-color: #000000a7;
    position: absolute;
    top: 0;
    left: 0;
    transition: all ease 0.5s;
    transform: translateY(100%);
    display:none;
  }
  .loginBox{
    margin-top: calc(50vh - 45vw);
    margin-left: 15vw;
    width: 70vw;
    height: 75vw;
    background-color: whitesmoke;
    border-radius: 3%;
    box-shadow: 3vw 3vw rgbargba(255, 255, 255, 0.896);
    text-align: center;
    font-family: "华文楷体";
  }
  .login_close{
    width: 8VW;
    height: 8VW;
    position: absolute;
    line-height: 8vw;
    color: white;
    margin-top: 2vw;
    margin-left: 60vw;
    border-radius: 1vw;
    background-color: #ad24099d;
  }
  .loginBox_title{
    font-size: 4.5vw;
    font-family: "华文行楷";
    height: 15vw;
    line-height: 20vw;
  }

  .loginBox_type button{
    width: 30vw;
    height: 10vw;
    background-color: #ffffff13;
    border: 0px solid #ffffff;
  }
  .mima{
    color: #0969b8;
    background: linear-gradient(to right, #ec695c, #61c454) no-repeat left bottom;
    background-size: 100% 2px;
  }
  .loginBox_inputs{
    margin-top: 3vw;
    width: 80%;
    height: 30%;
    display: flex;
    flex-direction: column;
    margin-left: 10%;
  }
  .loginBox_inputs input{
    width: 100%;
    height: 8vw;
    line-height: 8vw;
    background-color: #ffffff57;
    border-radius: 2vw;
    border: 2px solid #000000;
    margin-top: 2vw;
  }
  .loginBox_submit{
    width: 30vw;
    height: 10vw;
    background-color: #19b3b9ec;
    box-shadow: 0.3vw 0.3vw rgba(0, 0, 0, 0.708);
    border: 0px solid #ffffff;
    border-radius: 3vw;
    margin-top: 2vw;
  }
  .loginBox_tishi{
    margin-top: 2vw;
    font-size: 2vw;
    color: #bc7e5b;
  }
  .userinfo{
    width: 100%;
    height: 100%;
    z-index: 20;
    background-image: url('http://132.232.99.181:1111/img/userimgs/bgdefault.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    overflow: scroll;
    font-family: "华文中宋";
    transition: all ease 0.5s;
    transform: translateX(-100%);
  }
  .changebg, .closeuserinfo{
    width: 30px;
    height: 30px;
    position: absolute;
    right: 10px;
    top: 10px;
    border-radius: 1%;
    background-color: rgba(0, 0, 0, 0.384);
    box-shadow: 0.3vw 0.3vw rgba(0, 0, 0, 0.708);
    background-image: url('http://132.232.99.181:1111/img/cgbj.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .closeuserinfo{
    top: 10px;
    left: 10px;
    background-image: url('http://132.232.99.181:1111/img/fh.png');
    filter: brightness(1.2);
    border-radius: 50%;
  }
  .tx{
    width: 20vw;
    height: 20vw;
    position: absolute;
    top: 15vw;
    left: 10vw;
    background-color: #81d9d5;
    border-radius: 50%;
    border: 2px solid #ffffff;
    background-image: url('http://132.232.99.181:1111/img/userimgs/txdefault.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    box-shadow: 0.5vw 0.5vw rgba(0, 0, 0, 0.896);
  }
  .nc{
    width: 55vw;
    height: 8vw;
    position: absolute;
    top: 21vw;
    left: 35vw;
  }
  .nc_content{
    width: 54vw;
    height: 8vw;
    line-height: 8vw;
    font-size: 4.5vw;
    text-align: center;
    background-color: #0000005e;
    border-radius: 5%;
    color: white;
    font-family: "华文行楷";
  }
  .historySet{
    width: 80vw;
    height: 30vw;
    position: absolute;
    top: 45vw;
    left: 10vw;
    background-color: #00000083;
    color: white;
    border-radius: 5%;
  }
  .historySet_title{
    font-size: 4.5vw;
    font-family: "华文中宋";
    height: 10vw;
    line-height: 10vw;
  }
  .historySet_tisi{
    font-size: 2vw;
    font-family: "华文中宋";
    height: 8vw;
    line-height: 80vw;
  }
  .historySet_set{
    margin-top: 3vw;
    width: 40%;
    height: 8vw;
    text-align: center;
    line-height: 8vw;
    background-color: #00000044;
    border-radius: 10%;
    border: 2px solid #ffffff;
    color: white;
    font-family: "华文中宋";
  }
  .historySet_set option{
    background-color: #000000ad;
  }
  .myGeo{
    width: 80vw;
    height: 50vw;
    position: absolute;
    top: 85vw;
    left: 10vw;
    background-color: #00000083;
    color: white;
    border-radius: 5%;
    overflow:scroll;
  }
  .myGeo_title{
    font-size: 4.5vw;
    font-family: "华文中宋";
    height: 10vw;
    line-height: 10vw;
  }
  .myGeo_miniBox{
    margin-left: 2.5%;
    width: 95%;
    height: 8vw;
    display: flex;
    flex-direction: row;
    gap: 1vw;
    background-color: rgba(0, 0, 0, 0);
    font-size: 1vw !important;
  }
  .myGeo_miniBox div{
    width: 8vw;
    height: 8vw;
    line-height: 8vw;
    position: relative;
    flex-grow: 0;
    border-radius: 1%;
    background-color: rgba(0, 0, 0, 0.384);
    box-shadow: 0.3vw 0.3vw rgba(0, 0, 0, 0.708);
    color: white;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .myGeo_minidivactive{
    background-color: #ffd9008b !important;
  }
  .myGeo_miniName{
    width: 48vw !important;
    height: 8vw;
  }
  .myGeo_miniView{
    position: absolute;
    left: 0;
    top: 0;
    width: 8vw !important;
    height: 8vw !important;
    z-index: 5;
  }
  .gun{
    width: 60vw;
    height: 10vw;
    position: absolute;
    top: 145vw;
    left: 20vw;
    background-color: #00000083;
    color: rgb(152, 10, 10);
    border-radius: 5%;
    font-size: 4.5vw;
    font-family: "华文中宋";
    height: 10vw;
    line-height: 10vw;
  }
  .top {
    width: 100%;
    height: 115px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .userinforBtn{
    height: 30px;
    width: 30px;
    background-image: url('http://132.232.99.181:1111/img/info_ico.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    left: 10px;
    top:11px;
    position: absolute;
  }
  .top_title1{
    height: 20px;
    width: 100%;
    line-height: 20px;
    font-family: "华文中宋";
  }
  .top_title1_2{
    height: 35px;
    width: 100%;
    line-height: 15px;
    font-family: "华文中宋";
  }
  .top_title2{
    height: 60px;
    width: 100%;
    background-color: #00000064;
  }
  .top_title2 table{
    width: 100%;
    height: 100%;
    font-size: 8px;
    color: white;
  }
  .top_title2 td{
    height: 10px !important;
  }
  .top_title2 .top_oth{
    width: 14%;
  }
  .top_title2 .top_aqi{
    width: 16%;
  }
  .buttons{
    position: absolute;
    top: 120px;
  }
  #mapView {
    width: 100%;
    height: calc(100vh - 110px);
    top: 55px;
    left: 0;
    position: absolute;
    transition: all 0.5s;
  }
  .mapBLBtn{
    width: 9vw;
    height: 9vw;
    background-color: rgba(0, 0, 0, 0.337);
    position: absolute;
    left: 1vw;
    bottom: 2vw;
    color: aqua;
    font-size: 12px;
    z-index: 3;
    background-image: url("../assets/img/layercontrol.png");
    background-size: contain;
    background-repeat: no-repeat;
    transition: all ease 0.5s;
  }
  .DistanceTool, .AreaTool{
    width: 36vw;
    height: 10vw;
    display: flex;
    -ms-flex-item-align: center;
    position: absolute;
    bottom: 35vw;
    left: 31.5vw;
    gap: 4vw;
    z-index: -1;
    transition: all 0.5s;
    filter: blur(4vw);
    scale: 2;
    opacity: 0;
  }
  .DistanceTool div, .AreaTool div{
    width: 9vw;
    height: 9vw;
    background-color: rgba(0, 0, 0, 0.532);
    box-shadow: 0.3vw 0.3vw rgba(0, 0, 0, 0.708);
    color: aquamarine;
    line-height: 9vw;
    border-radius: 10%;
    font-size: 2vw;
  }
  .upData{
    width: 100%;
    height: 0vh;
    bottom: 10vh;
    left: 0;
    background-color: aliceblue;
    position: absolute;
    transition: all 0.5s;
    overflow: hidden;
    z-index: 6;
  }
  .upData input{
    width: 26%;
    height: 14%;
    position: absolute;
    left: 18%;
    top: 82%;
    background-color:rgba(217, 94, 41, 0.755);
  }
  .upTitle{
    color:rgb(0, 0, 0);
    font-size: 4vw;
    line-height: 4vw;
    height: 4vw;
    top: 1vw;
    position: absolute;
    width: 100%;
    left: 0;
    text-align: center;
  }
  .upData button{
    width: 25%;
    height: 15%;
    position: absolute;
    left: 60%;
    top: 82%;
    background-color: rgba(217, 94, 41, 0.755);
  }
  .upTable{
    width: 100%;
    height: 20vh;
    overflow: scroll;
    background-color: aliceblue;
  }
  .upDateInfo{
    width: 60vw;
    height: 30vw;
    position: relative;
  }
  .upDateInfo table{
    width: 100%;
    height: 80%;
    position: relative;
    overflow: scroll;
  }
  .upDateInfo td{
    text-align: center;
    height: 9vw;
  }
  .upDateInfo div{
    width: 100%;
    height: 6vw;
    line-height: 6vw;
    text-align: center;
  }
  .upDateInfo input{
    width: 25vw;
    height: 6vw;
  }
  .jiancedianBox{
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 1vw;
    width: 98vw;
    height: 60%;
    position: absolute;
    left: 1vw;
    top:15%;
  }
  .jiancedianwei{
    width: 100%;
    height: 100%;
    line-height: calc(0.44 * 17.5vw);
    text-align: center;
    border: 1px solid #000;
    background-color: aquamarine;
    font-size: 0.6vw;
    position: relative;
    color: rgb(142, 4, 62);
  }
  .jiancedianwei_2{
    line-height: calc(0.22 * 17.5vw) !important;
  }
  .jiancedianwei.data-saved {
    background-color: #f0f0f0 !important;
    border-color: #ccc !important;
    color: #000;
  }
  .opacityControl{
    top: calc(10vw + 60px);
    left: 12vw;
    position: absolute;
    width: 8vw;
    height: 30vw;
    line-height: 20vw;
    flex-grow: 0;
    border-radius: 1%;
    background-color: rgba(0, 0, 0, 0.384);
    box-shadow: 0.3vw 0.3vw rgba(0, 0, 0, 0.708);
    color: white;
    background-size: contain;
    background-repeat: no-repeat;
    transform: translateX(-30vw);
    opacity: 0;
    scale: 0.3;
    transition: all ease 0.5s;
  }
  #dur{
    margin-top: 4vw;
    margin-left: 3vw;
    width: 8px;
 
    height: 21vw;
    border-radius: 4px;
 
    background-size: 50% 100%;
    transform-origin: left center;
 
  }
  .durFont{
    position: absolute;
    height: 2vw;
    line-height: 2vw;
    bottom: 3px;
    width: 100%;
    text-align: center;
    font-size: 1.5vw;
  }
  .Echart_datas, .Echart_lines, .Echart_areas, .Echart_thres{
    height: 0px;
    width: 100%;
    left: 0;
    position: absolute;
    bottom: 0px;
    background-color: #00000071;
    border-radius: 5% 5% 0 0;
    background-color: rgba(0, 0, 0, 0.384);
    box-shadow: 0.3vw 0.3vw rgba(0, 0, 0, 0.708);
    transition: all ease 0.5s;
    overflow:hidden;
  }
  .Echart_thres{
    color: white;
  }
  .Echart_lines, .Echart_areas{
    font-size: 14px;
    color: white;
    line-height: 150px;
  }
  .Echart_datas_date{
    position: absolute;
    width: 104px;
    height: 140px;
    left: 46px;
    top: 0;
    z-index: 6;
    line-height: 126px;
    text-align: center;
    color: white;
    opacity: 0;
    transition: 0.5s;
  }
  #Echart_datas_left{
    position: absolute;
    width: 150px;
    height: 150px;
    left: 0;
    z-index: 6;
  }
  #Echart_datas_right{
    position: absolute;
    width: calc(100% - 150px);
    height: 150px;
    right: 0;
    z-index: 6;
  }
  .Echart_lines .tishi,.Echart_areas .tishi{
    width: 100%;
    height: 100%;
    line-height: 150px;
    text-align: center;
  }
  .Echart_lines_left{
    width: 100%;
    height:100%;
    left: 0;
    top: 0;
    position: absolute;
  }
  .Echart_areas_left{
    left: 0;
    top: 0;
    position: absolute;
    width: 50vw;
    height: 100%;
  }
  .Echart_areas_font{
    opacity: 0;
  }
  .Echart_areas_left_bottomFont_left, .Echart_areas_right_bottomFont_left{
    left: 3vw;
    bottom: 5px;
    position: absolute;
    width: 42vw;
    height: 15px;
    line-height: 15px;
    text-align: left;
  }
  .Echart_areas_left_bottomFont_right, .Echart_areas_right_bottomFont_right{
    left: 3vw;
    bottom: 5px;
    position: absolute;
    width: 42vw;
    height: 15px;
    line-height: 15px;
    text-align: right;
  }
  .Echart_areas_right_bottomFont_left, .Echart_areas_right_bottomFont_right{
    left: 53vw;
  }
  .Echart_areas_right{
    line-height: 20px;
    left: 50vw;
    top: 0;
    position: absolute;
    width: 50vw;
    height: 100%;
  }
  .Echart_thres_left, .Echart_thres_right{
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
  }
  .Echart_thres_right{
    font-size: 14px;
    left: 50%;
    display: flex;
    flex-direction: column;
    --rindex:255;
    --gindex:0;
    --bindex:0;
  }
  .ETR1,.ETR2,.ETR3,.ETR4{
    width: 100%;
    height: 40%;
    line-height: 60px;
    text-align: left;
    font-size: 14px;
    position: absolute;
    left: 0;
    top: 3px;
    overflow: hidden;
  }
  .ETR1{
    text-align: center;
    line-height: 20px;
  }
  .ETR2{
    top: 15% !important;
  }
  .ETR3{
    top: 40% !important;
  }
  .ETR4{
    top: 65% !important;
  }
  .Echart_thres_right div div{
    width: 80%;
    position: absolute;
    right: 5%;
    top: 25%;
  }
  .Echart_thres_left #yuzhi,.Echart_thres_left #Syuzhi{
    height: 60px;
    width: 90%;
    position: absolute;
    left: 5%;
    top: 22px;
  }
  #yuzhiTitle, #SyuzhiTitle{
    position: absolute;
    top: 3px;
    width: 100%;
    height: 15px;
    line-height: 15px;
    text-align: center;
    font-size: 14px;
  }
  #Syuzhi{
    top: 97px !important;
  }
  #SyuzhiTitle{
    top: 78px;
  }
  /* 设置Slider容器的背景透明 */
  .esri-slider {
    color: white;
    background-color: transparent !important;
  }
  /* 设置轨道（Track）背景透明 */
  .esri-slider__track {
    background-color: #81d9d5 !important;
  }
  
  /* 设置刻度线（Ticks）和标签的透明 */
  .esri-slider__tick-label {
    background-color: #81d9d5 !important;
  }
  .ETR2 .esri-slider__track{
    background-color: rgb(var(--rindex),0,0) !important;
  }
  .ETR3 .esri-slider__track{
    background-color: rgb(0,var(--gindex),0) !important;
  }
  .ETR4 .esri-slider__track{
    background-color: rgb(0,0,var(--bindex)) !important;
  }
  .layersBox{
    width: 73vw;
    height: 30vw;
    line-height: 30vw;
    color: aliceblue;
    font-size: 3vw;
    text-align: center;
    position: absolute;
    left: 15vw;
    bottom: 2vw;
    background-color: rgba(0, 0, 0, 0.264);
    z-index: 4;
    display: flex;
    flex-direction: column;
    gap: 1vw;
    padding: 1vw;
    overflow: scroll;
    transition: all 0.5s;
    transform: translateX(-450vw) translateY(100vw);
    scale: 0.1;
    opacity: 0;
  }
  .miniBox{
    width: 100%;
    height: 8vw;
    display: flex;
    flex-direction: row;
    gap: 1vw;
    background-color: rgba(0, 0, 0, 0.325);
    font-size: 1vw !important;
  }
  .miniBox div{
    width: 8vw;
    height: 8vw;
    line-height: 8vw;
    position: relative;
    flex-grow: 0;
    border-radius: 1%;
    background-color: rgba(0, 0, 0, 0.384);
    box-shadow: 0.3vw 0.3vw rgba(0, 0, 0, 0.708);
    color: white;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .minidivactive{
    background-color: #ffd9008b !important;
  }
  .miniName{
    width: 32vw !important;
    height: 8vw;
  }
  .miniView{
    position: absolute;
    left: 0;
    top: 0;
    width: 8vw !important;
    height: 8vw !important;
    z-index: 5;
  }
  .miniDiv1{
    background-color: aqua;
    background-image: url('../assets/img/see.png');
  }
  .miniDiv1_active{
    background-color: rgba(41, 41, 41, 0.762) !important;
    background-image: url('../assets/img/unsee.png');
  }
  .miniDiv2{
    background-image: url('../assets/img/fullScreen.png');
    background-color: aqua;
  }
  .miniDiv3{
    background-image: url('../assets/img/save.png');
  }
  .miniDiv4{
    background-image: url('../assets/img/close.png');
    background-color: rgb(233, 98, 20) !important;
  }
  .miniDiv5{
    background-image: url('../assets/img/add_ico.png');
    background-color: aqua;
  }
  .miniDiv6{
    background-image: url('../assets/img/close.png');
  }
  .relituBox{
    width: 100%;
    height: 0vh;
    bottom: 55px;
    left: 0;
    background-color: aliceblue;
    position: absolute;
    transition: all 0.5s;
    overflow:scroll;
    z-index: 6;
  }
  .relituBox select{
    width: 30vw;
    height: 10vw;
    position: absolute;
    left: 20vw;
    bottom: 6vw;
  }
  .AQI{
    position: absolute;
    width: 50%;
    top: 63px;
    left: 25%;
    aspect-ratio: 477 / 100;
    background-image: url('../assets/img/AQI.png');
    background-size: cover;
  }
  .relituControlBox, .Echart_datas_ControlBox{
    position: absolute;
    top: 0.8vh;
    left: 33.5%;
    width: 30%;
    height: 8vw;
    display:flex;
    -ms-flex-align: center;
  }
  .Echart_datas_ControlBox{
    width: 100px;
    left: 43px;
    top: 110px;
    opacity: 0;
    transition: 0.5s;
  }
  .relituControlBox div, .Echart_datas_ControlBox div{
    margin-top: 0.5vh;
    margin-left: 3vw;
    background-color: #00000060;
    color: rgb(0, 0, 0);
    height: 6vw;
    border-radius: 2vw;
    text-align: center;
    line-height: 6vw;
    border: rgb(0, 0, 0);
    border-style:solid;
    border-width: 1px;
    box-shadow: 0.3vw 0.3vw rgba(0, 0, 0, 0.708);
    transition: all ease 0.5s;
    width: 10vw !important;
    color: #0969b8;
  }
  .Echart_datas_ControlBox div{
    color: #ffa200;
    z-index: 7;
  }
  .relituControlBoxAct {
    background-color: #ffff007c !important; /* 激活状态颜色 */
  }
  .timelineBox{
    position: absolute;
    overflow: scroll;
    left: 0;
    bottom: 0vw;
    width: 100%;
    height: 40px;
    transition: all linear 0.5s;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
    
  }
  .timeline {
    width: calc(10 * var(--baselen));
    height: 1.5vw;
    position: absolute;
    left: 6vw;
    bottom: 20px;
  }
  .baseline{
    position: absolute;
    width: 100%;
    height: 2px;
    background: linear-gradient(to right, rgb(249, 167, 45) 0%,rgb(249, 167, 45) 100%);
    top: 50%;
    z-index: 2;
  }
  .topbaseline{
    position: absolute;
    width: 0%;
    height: 2px;
    background-color: rgb(212, 24, 196);
    top: 50%;
    transition: all ease 0.5s;
    z-index: 3;
  }
  .timeshowbox{
    position: absolute;
    left: calc(0% - 4vw);
    width: 20vw;
    height: 2.5vh;
    background-color: rgb(212, 24, 196);
    border-radius: 1vh 1vh 1vh 1vh;
    top: 7px;
    transition: all ease 0.5s;
    z-index: 3;
    line-height: 2.5vh;
    color: white;
    font-size: 6px;
    scale: 0.5;
  }
  .node {
    position: relative;
    width: 1.5vw;
    height: 1.5vw;
    border-radius: 50%;
    min-width: 8px;
    min-height: 8px;
    background-size: cover;
    position: absolute;
    transform: translateX(-50%);
    cursor: pointer;
    transition: transform 0.2s;
    background-color: rgb(19, 134, 152);
    z-index: 4;
  }
  .node_active{
    width: 2vw;
    height: 2vw;
    border-radius: 35%;
    min-width: 10px;
    min-height: 10px;
    transform: translateX(-50%) translateY(-12.5%);
    background-color: rgb(175, 6, 87);
  }
  .bottom {
    width: 100%;
    height: 55px;
    line-height: 55px;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 10;
    background-color: aliceblue;
    display: flex;
    font-size: calc(2.5 * var(--baselen));
    font-family: "楷体";
  }
  .historyBtn, .pridectBtn{
    text-align: center;
    flex-grow: 1;
    height:100%;
    transition: all ease 0.5s;
  }
  .historyBtnAct{
    flex-grow: 4;
    border-radius: 0 calc(10 * var(--baselen)) calc(10 * var(--baselen)) 0;
    background-color: #bc7e5b;
  }
  .historyBtnOff{
    flex-grow: 1;
    border-radius: 0 0 0 0;
    background-color: aliceblue;
  }
  .pridectBtnAct{
    flex-grow: 4;
    border-radius: calc(10 * var(--baselen)) 0 0 calc(10 * var(--baselen));
    background-color: #81d9d5;
  }
  .pridectBtnOff{
    flex-grow: 1;
    border-radius: 0 0 0 0;
    background-color: aliceblue;
  }
  .activeSomething{
    background-color: rgb(215, 181, 29) !important;
  }
  </style>